/* ============================================================
   LAYER'D Toolkit — the spine (workspace shell)
   SPINE r231 (step 3a). Mounts into #ld-toolkit. Reads the shared
   store only (window.LdCakeFile) — every number comes from
   readMoney()/predicates/cakeCore, no tool math is reimplemented
   here. Two modes: 'cake' (the booking spine + summary bar) and
   'quick' (flat standalone tools, nothing saved). The six steps run
   in two phases split by payment: quote (Size, Structure, Cost &
   price, Quote) then production (Recipes, Planner), production
   locked until the booking is confirmed/paid.
   ============================================================ */
(function () {
  var mount = document.getElementById('ld-toolkit');
  if (!mount) return;
  var F = window.LdCakeFile;
  if (!F) { mount.textContent = ''; return; }

  var UI_KEY = 'layerd-toolkit-ui';
  var ui = (function () {
    try { return JSON.parse(localStorage.getItem(UI_KEY)) || {}; } catch (e) { return {}; }
  })();
  function saveUi() { try { localStorage.setItem(UI_KEY, JSON.stringify(ui)); } catch (e) { } }
  /* UX 2026-09-10: the This cake page always opens fully collapsed. ui.open
     persists across a session's own taps, but a fresh page load starts clean —
     every section shut until the baker chooses one. */
  ui.open = null;
  /* SPINE r240: the shared bottom bar links to /pages/studio?view=bookings|account.
     Honour it once on load so those tabs land where they say. */
  try {
    /* UX 2026-09-07: added newcake, so the manifest "New inquiry" shortcut can
       land on the studio's New cake form (?view=newcake). */
    /* UX 2026-09-09: the param is `ldsp`, not `view` — `?view=` is a reserved
       Shopify parameter (alternate-template switch) and was rendering an ancient
       template instead of the studio. */
    var _mv = /[?&]ldsp=(bookings|account|newcake)/.exec(location.search);
    if (_mv) { ui.view = _mv[1]; saveUi(); }
    /* ?view=tools = the shared bottom bar's Tools tab, from a tool page */
    if (/[?&]ldsp=tools/.test(location.search)) {
      ui.mode = 'quick'; ui.view = 'cake';
      /* 2026-10-11: &tool=<step> opens that tool in the wide Tools view (the
         tools list on the Batch Math and Cake ER pages links back in here) */
      var _mt = /[?&]tool=(size|structure|cost|quote|recipes|planner)\b/.exec(location.search);
      if (_mt) ui.toolSel = _mt[1];
      saveUi();
    }
  } catch (e) { }
  /* UX 2026-09-07: ?booking=<id> opens that cake (the dashboard's continue
     card and any shared link land on the file, not on whatever was active). */
  try {
    var _mb = /[?&]booking=([^&]+)/.exec(location.search);
    if (_mb && F.setActiveBooking) {
      var _bid = decodeURIComponent(_mb[1]);
      var _st = F.readStore ? F.readStore() : null;
      if (!_st || !_st.bookings || _st.bookings.some(function (x) { return x.id === _bid; })) {
        F.setActiveBooking(_bid, 'toolkit'); ui.view = 'cake'; ui.mode = 'cake'; saveUi();
      }
    }
  } catch (e) { }

  /* ---- currency (symbol-only, worldwide; never converted) ---- */
  /* UX 2026-09-07: default to the storefront's own market currency (passed in
     on the mount as data-lh-currency) instead of a hard USD, so a CAD shop
     reads right before the baker ever opens Settings. */
  function curDefault() {
    try { var c = mount.getAttribute('data-lh-currency'); return (c && /^[A-Z]{3}$/.test(c)) ? c : 'USD'; } catch (e) { return 'USD'; }
  }
  function curCode() { try { return localStorage.getItem('layerd-learn-currency') || curDefault(); } catch (e) { return curDefault(); } }
  function curSet(code) {
    code = (code || '').toUpperCase().replace(/[^A-Z]/g, '').slice(0, 3);
    if (code.length !== 3) return false;
    try { localStorage.setItem('layerd-learn-currency', code); } catch (e) { }
    return true;
  }
  function curSymbol(code) {
    try {
      var parts = new Intl.NumberFormat(undefined, { style: 'currency', currency: code || curCode() }).formatToParts(0);
      var s = parts.filter(function (p) { return p.type === 'currency'; })[0];
      return s ? s.value : (code || curCode());
    } catch (e) { return code || '$'; }
  }
  function fmtMoney(n, whole) {
    if (n == null || isNaN(+n)) return null;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: curCode(), maximumFractionDigits: whole ? 0 : 2 }).format(+n);
    } catch (e) { return '$' + (+n).toFixed(whole ? 0 : 2); }
  }
  /* ---- units + first-run settings gate ---- */
  var UNITS_KEY = 'layerd-learn-units';
  function unitsNow() { try { return localStorage.getItem(UNITS_KEY) === 'cm' ? 'cm' : 'in'; } catch (e) { return 'in'; } }
  function unitsSet(u) { try { localStorage.setItem(UNITS_KEY, u === 'cm' ? 'cm' : 'in'); } catch (e) { } }
  var SETTINGS_SEEN = 'layerd-toolkit-settings-seen';
  function settingsSeen() { try { return !!localStorage.getItem(SETTINGS_SEEN); } catch (e) { return true; } }
  function markSettingsSeen() { try { localStorage.setItem(SETTINGS_SEEN, '1'); } catch (e) { } }

  /* ---- tiny DOM helper ---- */
  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (k === 'class') n.className = attrs[k];
      else if (k === 'html') n.innerHTML = attrs[k];
      else if (k === 'text') n.textContent = attrs[k];
      else if (k.slice(0, 2) === 'on' && typeof attrs[k] === 'function') n.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] != null) n.setAttribute(k, attrs[k]);
    }
    (kids || []).forEach(function (c) { if (c == null) return; n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }

  var TOOL_PATHS = {
    serving: '/pages/serving-size-calculator', structure: '/pages/structure',
    pricing: '/pages/pricing', batch: '/pages/batch-math', 'recipe-library': '/pages/recipe-library',
    planner: '/pages/planner', 'cake-er': '/pages/cake-er'
  };
  function toolUrl(tool, id) {
    var base = (window.LDSP_TOOL_BASE && window.LDSP_TOOL_BASE[tool]) || TOOL_PATHS[tool] || ('/pages/' + tool);
    var q = id ? ((base.indexOf('?') > -1 ? '&' : '?') + 'booking=' + encodeURIComponent(id)) : '';
    return base + q;
  }
  /* opening a tool from the workspace: carry a return path so the tool's back
     link comes home to the studio (learn-components.js rewrites it). */
  var STUDIO_PATH = '/pages/studio';
  function withReturn(u) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'return=' + encodeURIComponent(STUDIO_PATH); }
  function doorHref(tool, id) { return withReturn(toolUrl(tool, id)); }
  /* the Planner scopes by ?file= (never ?booking=). UX 2026-09-10: the Planner
     is now just the production checklist + shopping list (the calendar and
     client files live here in the Studio), so ?file= lands on this cake's
     checklist. Used by the Planner step door and the date pill in the header. */
  function plannerBase() { return (window.LDSP_TOOL_BASE && window.LDSP_TOOL_BASE.planner) || TOOL_PATHS.planner; }
  function plannerHref(b) {
    return withReturn(plannerBase() + '?file=' + encodeURIComponent(b.id));
  }
  /* straight to this cake's shopping list in the Planner */
  function plannerShopHref(b) {
    return withReturn(plannerBase() + '?file=' + encodeURIComponent(b.id) + '&ldview=shopping');
  }
  /* one-tap batch: Batch Math runs its own "whole cake" save with the file's
     defaults and returns here, so the amounts fill in without a manual trip. */
  function batchAutoHref(b) { return doorHref('batch', b.id) + '&autobatch=1'; }
  /* a real tool embedded in a step: scoped to the booking, chrome hidden
     (?embed=1 → html.ld-embed in that tool's CSS) */
  function embedUrl(tool, id) {
    var base = (window.LDSP_TOOL_BASE && window.LDSP_TOOL_BASE[tool]) || TOOL_PATHS[tool] || ('/pages/' + tool);
    /* the Planner scopes to a file via ?file= (its detail deep-link); the rest
       scope via ?booking= */
    var param = (tool === 'planner') ? 'file' : 'booking';
    var sep = base.indexOf('?') > -1 ? '&' : '?';
    return base + sep + param + '=' + encodeURIComponent(id) + '&embed=1';
  }
  function toolFrame(tool, id, title) {
    var frame = el('iframe', { class: 'ldsp-frame', src: embedUrl(tool, id), title: title, loading: 'lazy', scrolling: 'no' });
    return el('div', { class: 'ldsp-framewrap' }, [frame]);
  }

  var P = F.predicates || {};
  function pred(name, b) { try { return !!(P[name] && P[name](b)); } catch (e) { return false; } }
  function isPaid(b) { return pred('isBooked', b); }   /* confirmed booking = the quote was accepted/paid */

  /* ---- the six spine steps, her two-phase order ---- */
  var STEPS = [
    { id: 'size', name: 'Size', phase: 'quote', tool: 'serving', quick: 'tap to size' },
    { id: 'structure', name: 'Structure', phase: 'quote', tool: 'structure', quick: 'dowels & boards' },
    { id: 'cost', name: 'Cost & price', phase: 'quote', tool: 'pricing', quick: 'price a cake' },
    { id: 'quote', name: 'Quote', phase: 'quote', tool: 'pricing', quick: 'draft a quote' },
    /* UX 2026-09-14 (Mariya: "for production can we move design before
       recipes?"). Design leads the production phase now — the inspo and palette
       are the first thing gathered, and they never lock (see stepState), so
       they open the block. Recipes and Planner follow. */
    { id: 'clientfile', name: 'Design', phase: 'production', tool: 'planner', quick: 'inspo & palette' },
    { id: 'recipes', name: 'Recipes', phase: 'production', tool: 'recipe-library', quick: 'scale a recipe' },
    { id: 'planner', name: 'Planner', phase: 'production', tool: 'planner', quick: 'build a timeline' }
  ];

  /* UX 2026-09-09: the Tools tab is the tool directory — the calculators above
     plus doors to the rest. Bloom Atlas and Pantry are plumbed but hidden until
     they're finished: flip `hidden` to show them (their paths resolve via
     toolUrl's /pages/<id> fallback). */
  var TOOL_DIRECTORY = [
    /* 2026-09-18 (Mariya): Build Sheets and Bloom Atlas live in the Academy only,
       so they are NOT listed here. The Toolkit Tools tab is the Toolkit's own
       standalone calculators. */
    /* UX 2026-09-11 (Mariya): Batch Math was only reachable inside a booking's
       Recipes step, never as a standalone tool. It's a calculator in its own
       right, so it gets a Tools-tab door (id resolves via /pages/<id>). */
    { id: 'batch-math', name: 'Batch Math', sub: 'Scale any recipe to your exact tiers and pan sizes.', hidden: false },
    { id: 'cake-er', name: 'Cake ER', sub: 'Something going wrong? The diagnosis is always free.', hidden: false },
    { id: 'pantry', name: 'Pantry', sub: 'What to buy and why, ingredient by ingredient.', hidden: true }
  ];

  /* the settings gear on the This cake / Tools headers (Mariya: "I can't find
     the settings button anywhere") — opens the Settings view, same as the tab */
  function gearBtn() {
    var g = el('button', { class: 'ldsp-gear', type: 'button', 'aria-label': 'Settings', title: 'Settings', html:
      /* 2026-09-14 (Mariya): use the native pages' outline GEAR, not the
         sun-looking rays icon. Same paths as .ld-setgear (learn-components). */
      '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="3.2"></circle><path d="M19.4 13.5a7.6 7.6 0 0 0 0-3l1.7-1.3-1.8-3.1-2 .8a7.6 7.6 0 0 0-2.6-1.5L14.4 3h-3.6l-.3 2.4a7.6 7.6 0 0 0-2.6 1.5l-2-.8-1.8 3.1 1.7 1.3a7.6 7.6 0 0 0 0 3l-1.7 1.3 1.8 3.1 2-.8a7.6 7.6 0 0 0 2.6 1.5l.3 2.4h3.6l.3-2.4a7.6 7.6 0 0 0 2.6-1.5l2 .8 1.8-3.1z"></path></svg>' });
    g.addEventListener('click', function () { ui.view = 'settings'; saveUi(); render(); });
    return g;
  }

  function stepState(st, b, money, isCake) {
    var done = false, answer = st.quick;
    if (isCake && b) {
      switch (st.id) {
        case 'size': done = pred('sizeConfirmed', b) || (money && money.servings > 0); answer = (money && money.servings > 0) ? (money.servings + ' servings') : '—'; break;
        case 'structure': done = pred('structureDone', b); answer = (b.tiers || 0) + (b.tiers === 1 ? ' tier' : ' tiers'); break;
        case 'cost': done = !!(money && money.priced); answer = (money && money.chargeSv != null) ? (fmtMoney(money.chargeSv) + '/sv') : 'not priced'; break;
        case 'quote': done = pred('quoteDone', b); answer = (money && money.quote != null) ? fmtMoney(money.quote, true) : '—'; break;
        /* UX 2026-09-11: batch math was easy to overlook because the step read
           "done" once flavours were set. Now it needs BOTH — flavours and the
           batch amounts — so the checkmark tells the truth. */
        case 'recipes': {
          var flavOk = pred('flavoursDone', b), batOk = pred('batchDone', b);
          done = flavOk && batOk;
          answer = !flavOk ? 'flavours' : !batOk ? 'batch not set' : 'ready';
          break;
        }
        case 'planner': done = pred('bookedDone', b); answer = b.date ? prettyDate(b.date).replace(' ›', '') : 'plan the week'; break;
        case 'clientfile': {
          var FD0 = window.LAYERD && window.LAYERD.fileDesign;
          var dz0 = FD0 ? FD0.readDesign(b) : { inspo: [], palette: [] };
          var np = dz0.inspo.length;
          done = np > 0 || dz0.palette.length > 0;
          answer = np ? (np + (np === 1 ? ' photo' : ' photos')) : 'add inspo';
          break;
        }
      }
    }
    /* the client file is reference material (inspo gathered from first contact),
       so it never sits behind the production lock the other steps do */
    var locked = isCake && st.phase === 'production' && st.id !== 'clientfile' && !isPaid(b);
    return { done: done, answer: answer, locked: locked };
  }

  /* ---- step bodies (3a: real answers + the scoped door into each tool) ---- */
  function cakeDrawing(b) {
    var C = window.LAYERD && window.LAYERD.cakeCore;
    if (!C || !C.renderStack || !b) return null;
    try {
      var stack = (F.specOf(b) || []).map(function (t) { return { size: +t.d, height: +t.h || 4, shape: t.shape === 'square' ? 'square' : (t.shape === 'heart' ? 'heart' : 'round') }; });
      if (!stack.length) return null;
      var out = C.renderStack(stack);
      var wrap = el('div', { class: 'ldsp-cake' });
      if (typeof out === 'string') wrap.innerHTML = out;
      else if (out && out.nodeType) wrap.appendChild(out);
      else return null;
      return wrap;
    } catch (e) { return null; }
  }
  function row(k, v) { return el('div', { class: 'ldsp-row' }, [el('span', { class: 'ldsp-row__k', text: k }), el('span', { class: 'ldsp-row__v', text: v })]); }

  /* ---- native Size lift (step 3b): a tier builder bound to the shared
     engine (cakeCore.servingsFor — the one owner) and the store (writeCake /
     writeScratch). No servings math is reimplemented here. ---- */
  var HEIGHTS = [3, 4, 5, 6, 7, 8];
  function sizesFor(shape) {
    var C = window.LAYERD && window.LAYERD.cakeCore;
    var tbl = C && C.SERVINGS && C.SERVINGS[shape];
    return tbl ? Object.keys(tbl).map(Number).sort(function (a, b) { return a - b; }) : [6, 8, 10];
  }
  /* the free Pricing ballpark island (bands + orderMin), if the host page
     carries it — budget sizing reads it, same source the Serving page uses. */
  function readBallpark() {
    try { var e = document.getElementById('ldc-ballpark'); var bp = e ? JSON.parse(e.textContent) : null; return (bp && bp.bands) ? bp : null; } catch (x) { return null; }
  }
  function sizeBuilder(b, isCake) {
    var C = window.LAYERD && window.LAYERD.cakeCore;
    if (!C || !C.servingsFor) return null;
    var inch = C.sizeLabel || function (n) { return n + '″'; };
    /* quick mode ALWAYS works the anonymous scratch cake — read it directly,
       because readCake() prefers the active booking when one exists (which is
       why the occasion toggle and add-tier looked dead in Quick tools). */
    var rc = (isCake && b) ? (F.readCake ? F.readCake() : { tiers: [], meta: {} })
                           : (F.readScratch ? F.readScratch() : { tiers: [], meta: {} });
    var tiers = (rc.tiers && rc.tiers.length) ? rc.tiers.map(function (t) { return { shape: t.shape === 'square' ? 'square' : (t.shape === 'heart' ? 'heart' : 'round'), d: +t.d || 6, h: +t.h || 4 }; }) : [{ shape: 'round', d: 6, h: 4 }];
    var occ = (rc.meta && rc.meta.occasion === 'party') ? 'party' : 'wedding';
    var mode = (ui.sizeMode === 'guests' || ui.sizeMode === 'budget') ? ui.sizeMode : 'tiers';

    function commit(next) {
      if (!next.length) return;
      if (isCake && b) F.writeCake(next, 'toolkit', { occasion: occ });
      else F.writeScratch(next, 'toolkit', { occasion: occ });
      /* the store fires layerd:cakefile → onChange → render(); no manual redraw */
    }
    function setOcc(o) {
      occ = o;
      /* write the CURRENT tier rows (from the DOM), not the stale initial
         array — otherwise a size edit made before toggling would be lost. */
      if (isCake && b) F.writeOccasion(o, 'toolkit'); else F.writeScratch(collect(tiersWrap), 'toolkit', { occasion: o });
    }
    function collect(wrap) {
      return Array.prototype.map.call(wrap.querySelectorAll('.ldsp-tier'), function (r) {
        var s = r.querySelectorAll('select');
        return { shape: s[0].value, d: parseInt(s[1].value, 10), h: parseInt(s[2].value, 10), layers: 3, flavour: '' };
      });
    }
    function selEl(opts, val, on) {
      var s = el('select', { onchange: on });
      opts.forEach(function (o) { var op = el('option', { value: String(o.v) }, [o.l]); if (String(o.v) === String(val)) op.selected = true; s.appendChild(op); });
      return s;
    }
    /* apply a recommended combo (guests / budget) as the cake: uniform height,
       round tiers — then drop back to the tier builder to fine-tune. */
    function applyCombo(c) {
      var next = c.sizes.map(function (s) { return { shape: 'round', d: s, h: c.height, layers: 3, flavour: '' }; });
      ui.sizeMode = 'tiers'; saveUi();
      commit(next);           /* fires the store event → full render into tiers mode */
    }

    var tiersWrap = el('div', { class: 'ldsp-tiers' });

    /* ---- the mode switch: tiers / guests / budget ---- */
    function modeSwitch() {
      function mb(id, label) {
        return el('button', { type: 'button', class: 'ldsp-sizemode' + (mode === id ? ' is-on' : ''), 'aria-pressed': String(mode === id), onclick: function () { ui.sizeMode = id; saveUi(); render(); } }, [label]);
      }
      return el('div', { class: 'ldsp-sizemodes' }, [mb('tiers', 'By tiers'), mb('guests', 'By guests'), mb('budget', 'By budget')]);
    }
    /* a self-contained occasion toggle (used by guests/budget; manages its own
       active state so re-running the search doesn't need a full render) */
    function occToggle(onset) {
      var w = el('div', { class: 'ldsp-occ' });
      ['wedding', 'party'].forEach(function (val) {
        var lbl = val === 'wedding' ? 'Wedding slice' : 'Party slice';
        var btn = el('button', { type: 'button', class: (occ === val ? 'is-on' : ''), onclick: function () {
          occ = val;
          Array.prototype.forEach.call(w.children, function (x) { x.classList.remove('is-on'); });
          btn.classList.add('is-on'); onset();
        } }, [lbl]);
        w.appendChild(btn);
      });
      return w;
    }
    function prefTierField(onset) {
      var sel = selEl([{ v: 0, l: 'Any number of tiers' }, { v: 1, l: '1 tier' }, { v: 2, l: '2 tiers' }, { v: 3, l: '3 tiers' }, { v: 4, l: '4 tiers' }], ui.sizePrefTiers || 0, function () { ui.sizePrefTiers = parseInt(sel.value, 10) || 0; saveUi(); onset(); });
      return el('label', { class: 'ldsp-field' }, [el('span', { class: 'ldsp-field__lbl', text: 'Preferred look' }), sel]);
    }
    function comboDraw(c) {
      try {
        var out = C.renderStack(c.sizes.map(function (s) { return { size: s, height: c.height, shape: 'round' }; }));
        var w = el('div', { class: 'ldsp-cake ldsp-rec__cake' });
        if (typeof out === 'string') w.innerHTML = out; else if (out && out.nodeType) w.appendChild(out); else return null;
        return w;
      } catch (e) { return null; }
    }
    function fmtRange(lo, hi) { return fmtMoney(lo, true) + ' – ' + fmtMoney(hi, true); }
    /* UX 2026-09-09: the whole card is the tap target — no per-card "Use" button
       (it only ever showed on the closest match, which read as inconsistent).
       Every card shows its tier height, so the rows line up. */
    function recCard(c, isBudget, isStretch, isClosest) {
      var sub = c.total + ' servings' + (isBudget ? '  ·  ' + fmtRange(c.lo, c.hi) : '');
      var meta = el('div', { class: 'ldsp-rec__meta' }, [
        el('div', { class: 'ldsp-rec__stack', text: c.sizes.map(function (s) { return inch(s); }).join(' + ') + '  ·  ' + (c.height || 4) + '″ tall' }),
        el('div', { class: 'ldsp-rec__sub', text: sub })
      ]);
      if (isBudget) meta.appendChild(el('div', { class: 'ldsp-rec__badge' + (isStretch ? ' is-stretch' : '') }, [isStretch ? 'a stretch' : 'fits the budget']));
      var card = el('div', {
        class: 'ldsp-rec' + (isClosest ? ' ldsp-rec--closest' : ''), role: 'button', tabindex: '0',
        'aria-label': 'Use the ' + c.sizes.map(function (s) { return inch(s); }).join(' + ') + ' cake, ' + c.total + ' servings'
      }, [comboDraw(c), meta].filter(Boolean));
      function use() { applyCombo(c); }
      card.addEventListener('click', use);
      card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); use(); } });
      return card;
    }
    function renderRecs(container, rec, isBudget) {
      container.innerHTML = '';
      if (!rec || !rec.combos || !rec.combos.length) { container.appendChild(el('div', { class: 'ldsp-body__note', text: 'No cake found for that. Try a different number.' })); return; }
      if (rec.shortfall) container.appendChild(el('div', { class: 'ldsp-locked-note', text: isBudget ? 'Nothing fits that budget. The smallest cake:' : 'That is a big crowd for a stacked cake. The largest stack:' }));
      if (rec.prefMiss) container.appendChild(el('div', { class: 'ldsp-locked-note', text: 'No cake at that tier count fits. Closest fits:' }));
      rec.combos.forEach(function (c, i) { container.appendChild(recCard(c, isBudget, isBudget && rec.stretchFrom != null && i >= rec.stretchFrom, i === 0)); });
    }

    /* ---- MODE: by guests ---- */
    function guestsBody() {
      var results = el('div', { class: 'ldsp-recs' });
      var input = el('input', { class: 'ldsp-input', type: 'number', inputmode: 'numeric', min: '1', max: '2000', placeholder: 'e.g. 100', value: ui.sizeGuests || '' });
      function run() {
        ui.sizeGuests = input.value; saveUi();
        var n = parseInt(input.value, 10);
        if (!n || n < 1) { results.innerHTML = ''; results.appendChild(el('div', { class: 'ldsp-body__note', text: 'Type a guest count and tap Find cakes.' })); return; }
        renderRecs(results, C.recommendStack(n, occ, { prefTiers: ui.sizePrefTiers || 0 }), false);
      }
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
      var wrap = el('div', { class: 'ldsp-sb' }, [
        occToggle(function () { if (parseInt(input.value, 10) > 0) run(); }),
        el('label', { class: 'ldsp-field' }, [el('span', { class: 'ldsp-field__lbl', text: 'How many guests?' }), input]),
        prefTierField(function () { if (parseInt(input.value, 10) > 0) run(); }),
        el('button', { class: 'ldsp-open', type: 'button', onclick: run }, ['Find cakes →']),
        results,
        el('div', { class: 'ldsp-body__note', text: 'One serving per guest, from the Wilton chart, ranked to the pans you own. Pick one to set the cake.' })
      ]);
      if (parseInt(ui.sizeGuests, 10) > 0) run();
      return wrap;
    }

    /* ---- MODE: by budget ---- */
    function budgetBody() {
      var bp = readBallpark();
      if (!bp) {
        return el('div', { class: 'ldsp-sb' }, [
          el('div', { class: 'ldsp-locked-note', text: 'Budget sizing needs the ballpark rates, which live with Pricing.' }),
          el('a', { class: 'ldsp-open', href: doorHref('pricing', b ? b.id : null) }, ['Set up pricing →'])
        ]);
      }
      var bandKeys = Object.keys(bp.bands);
      if (!ui.sizeBudgetBand || bandKeys.indexOf(ui.sizeBudgetBand) === -1) ui.sizeBudgetBand = bandKeys[0];
      var results = el('div', { class: 'ldsp-recs' });
      var input = el('input', { class: 'ldsp-input', type: 'number', inputmode: 'numeric', min: '1', placeholder: 'e.g. 400', value: ui.sizeBudget || '' });
      var bandSel = selEl(bandKeys.map(function (k) { return { v: k, l: (bp.labels && bp.labels[k]) || k }; }), ui.sizeBudgetBand, function () { ui.sizeBudgetBand = bandSel.value; saveUi(); run(); });
      function run() {
        ui.sizeBudget = input.value; saveUi();
        var amt = parseInt(input.value, 10);
        if (!amt || amt < 1) { results.innerHTML = ''; results.appendChild(el('div', { class: 'ldsp-body__note', text: 'Type a budget and tap Find cakes.' })); return; }
        renderRecs(results, C.recommendBudget(amt, occ, { prefTiers: ui.sizePrefTiers || 0, ballpark: bp, band: ui.sizeBudgetBand }), true);
      }
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
      var wrap = el('div', { class: 'ldsp-sb' }, [
        occToggle(function () { if (parseInt(input.value, 10) > 0) run(); }),
        el('label', { class: 'ldsp-field' }, [el('span', { class: 'ldsp-field__lbl', text: 'Client budget' }), input]),
        el('label', { class: 'ldsp-field' }, [el('span', { class: 'ldsp-field__lbl', text: 'Cover' }), bandSel]),
        prefTierField(function () { if (parseInt(input.value, 10) > 0) run(); }),
        el('button', { class: 'ldsp-open', type: 'button', onclick: run }, ['Find cakes →']),
        results,
        el('div', { class: 'ldsp-body__note', text: 'A ballpark range from the free Pricing rates, not your own. The exact quote is in Cost & price. Pick one to set the cake.' })
      ]);
      if (parseInt(ui.sizeBudget, 10) > 0) run();
      return wrap;
    }

    /* ---- MODE: by tiers (the manual builder) ---- */
    function tiersBody() {
      function tierRow(t, i) {
        var shapeSel = selEl([{ v: 'round', l: 'Round' }, { v: 'square', l: 'Square' }, { v: 'heart', l: 'Heart' }], t.shape, function () { commit(collect(tiersWrap)); });
        var sizeSel = selEl(sizesFor(t.shape).map(function (d) { return { v: d, l: d + '″' }; }), t.d, function () { commit(collect(tiersWrap)); });
        var htSel = selEl(HEIGHTS.map(function (h) { return { v: h, l: h + '″ tall' }; }), t.h, function () { commit(collect(tiersWrap)); });
        var rm = el('button', { class: 'ldsp-tier__rm', type: 'button', 'aria-label': 'Remove tier', onclick: function () { var next = collect(tiersWrap); next.splice(i, 1); commit(next.length ? next : [{ shape: 'round', d: 6, h: 4 }]); } }, ['×']);
        return el('div', { class: 'ldsp-tier' }, [shapeSel, sizeSel, htSel, rm]);
      }
      tiers.forEach(function (t, i) { tiersWrap.appendChild(tierRow(t, i)); });
      var total = 0;
      tiers.forEach(function (t) { total += C.servingsFor(t.shape, t.d, occ, t.h); });
      /* UX 2026-09-09: only mirror the booking's saved cake when we're actually
         editing it. In Quick tools the builder works the scratch cake, but an
         active booking can still be set — cakeDrawing(b) would then freeze the
         drawing on that booking while the rows/servings track scratch. Draw
         from the local tiers instead (read from the right source per mode). */
      var draw = (isCake && b ? cakeDrawing(b) : null) || (function () {
        try {
          var stack = tiers.map(function (t) { return { size: t.d, height: t.h, shape: t.shape === 'square' ? 'square' : (t.shape === 'heart' ? 'heart' : 'round') }; });
          var out = C.renderStack(stack); var w = el('div', { class: 'ldsp-cake' });
          if (typeof out === 'string') w.innerHTML = out; else if (out && out.nodeType) w.appendChild(out); else return null;
          return w;
        } catch (e) { return null; }
      })();
      var kids = [
        el('div', { class: 'ldsp-occ' }, [
          el('button', { type: 'button', class: (occ === 'wedding' ? 'is-on' : ''), onclick: function () { setOcc('wedding'); } }, ['Wedding slice']),
          el('button', { type: 'button', class: (occ === 'party' ? 'is-on' : ''), onclick: function () { setOcc('party'); } }, ['Party slice'])
        ]),
        tiersWrap,
        el('button', { class: 'ldsp-addtier', type: 'button', onclick: function () { var next = collect(tiersWrap); var last = next[next.length - 1] || { shape: 'round', d: 6, h: 4 }; next.push({ shape: last.shape, d: last.d, h: last.h, layers: 3, flavour: '' }); commit(next); } }, ['+ Add a tier'])
      ];
      if (draw) kids.push(draw);
      kids.push(el('div', { class: 'ldsp-sizeout' }, [el('span', { class: 'ldsp-sizeout__k', text: 'Servings' }), el('span', { class: 'ldsp-sizeout__v', text: String(total) })]));
      kids.push(el('div', { class: 'ldsp-body__note', text: 'Wilton slice, scaled by height. The same Serving engine every step reads.' }));
      return el('div', { class: 'ldsp-sb' }, kids);
    }

    var body = mode === 'guests' ? guestsBody() : mode === 'budget' ? budgetBody() : tiersBody();
    return el('div', {}, [modeSwitch(), body]);
  }

  /* native Structure lift (step 3b): the dowel/board plan from the SHARED
     structure engine (window.LAYERD.structureCore) — same math as the tool. */
  /* UX 2026-09-11 (Mariya): a real draggable colour spectrum. The native
     <input type="color"> on phones only picks where you first tap — you can't
     drag a finger to explore. This is a pointer/touch-driven saturation-value
     box + hue slider with a live preview, then Add. */
  function hsvToHex(h, s, v) {
    var c = v * s, x = c * (1 - Math.abs((h / 60) % 2 - 1)), m = v - c, r = 0, g = 0, bl = 0;
    if (h < 60) { r = c; g = x; } else if (h < 120) { r = x; g = c; } else if (h < 180) { g = c; bl = x; }
    else if (h < 240) { g = x; bl = c; } else if (h < 300) { r = x; bl = c; } else { r = c; bl = x; }
    function hx(n) { return ('0' + Math.round((n + m) * 255).toString(16)).slice(-2); }
    return ('#' + hx(r) + hx(g) + hx(bl)).toUpperCase();
  }
  function colourSpectrum(onAdd) {
    var h = 210, s = 0.55, v = 0.7;
    var sv = el('div', { class: 'ldsp-cpick__sv' });
    var svThumb = el('div', { class: 'ldsp-cpick__svthumb' }); sv.appendChild(svThumb);
    var hue = el('div', { class: 'ldsp-cpick__hue' });
    var hueThumb = el('div', { class: 'ldsp-cpick__huethumb' }); hue.appendChild(hueThumb);
    var chip = el('span', { class: 'ldsp-cpick__chip' });
    var hexLbl = el('span', { class: 'ldsp-cpick__hex' });
    var add = el('button', { class: 'ldsp-cpick__add', type: 'button' }, ['Add this colour']);
    function clamp(n) { return n < 0 ? 0 : n > 1 ? 1 : n; }
    function paint() {
      sv.style.background = 'linear-gradient(to top, #000, rgba(0,0,0,0)), linear-gradient(to right, #fff, rgba(255,255,255,0)), hsl(' + Math.round(h) + ',100%,50%)';
      svThumb.style.left = (s * 100) + '%'; svThumb.style.top = ((1 - v) * 100) + '%';
      hueThumb.style.left = (h / 360 * 100) + '%';
      var hex = hsvToHex(h, s, v);
      chip.style.background = hex; svThumb.style.background = hex;
      hexLbl.textContent = hex + ((FD_NAME && FD_NAME(hex)) ? ('  ·  ' + FD_NAME(hex)) : '');
      return hex;
    }
    function drag(elm, onMove) {
      var active = false;
      function pt(e) { var r = elm.getBoundingClientRect(); return { x: clamp((e.clientX - r.left) / r.width), y: clamp((e.clientY - r.top) / r.height) }; }
      elm.addEventListener('pointerdown', function (e) { active = true; e.preventDefault(); try { elm.setPointerCapture(e.pointerId); } catch (x) { } onMove(pt(e)); });
      elm.addEventListener('pointermove', function (e) { if (!active) return; e.preventDefault(); onMove(pt(e)); });
      elm.addEventListener('pointerup', function (e) { active = false; try { elm.releasePointerCapture(e.pointerId); } catch (x) { } });
      elm.addEventListener('pointercancel', function () { active = false; });
    }
    drag(sv, function (p) { s = p.x; v = 1 - p.y; paint(); });
    drag(hue, function (p) { h = p.x * 360; paint(); });
    add.addEventListener('click', function () { onAdd(paint()); });
    paint();
    return el('div', { class: 'ldsp-cpick' }, [sv, hue, el('div', { class: 'ldsp-cpick__row' }, [chip, hexLbl, add])]);
  }
  var FD_NAME = null;   /* set in clientFileBody once fileDesign is resolved */
  /* 2026-09-21 (Mariya): the Planner step shows a neat read-only table by
     default; "edit details" reveals the date + delivery controls. Session-only,
     so it always opens back on the tidy table. */
  var plannerEditOpen = false;

  /* UX 2026-09-08: the Client file — inspiration images + colour palette, both
     stored on the booking via the shared fileDesign engine (thumbs sync; full
     images are device-local IndexedDB). Full upload + editing lives here, not
     only in the Planner. Every mutation writes through fileDesign.writeDesign,
     and the store re-render redraws this section. */
  function clientFileBody(b) {
    var FD = window.LAYERD && window.LAYERD.fileDesign;
    if (!FD) return el('div', { class: 'ldsp-body__note', text: 'The design tools are still loading. Refresh if this stays.' });
    FD_NAME = (FD && FD.nameOf) ? FD.nameOf : null;   /* the spectrum's live name label */
    var d = FD.readDesign(b);
    var kids = [];

    /* ---- colour palette ---- */
    kids.push(el('div', { class: 'ldsp-subhead', text: 'Colour palette' }));
    var pal = el('div', { class: 'ldsp-palette' });
    if (d.palette.length) {
      d.palette.forEach(function (c, i) {
        /* UX 2026-09-09: the name comes from the hex automatically (nearest
           named colour, in Lab — fileDesign.nameOf); an unnamed legacy swatch is
           named here and persists on the next write. Tap the name to rename. */
        if (!c.name && FD.nameOf) c.name = FD.nameOf(c.hex);
        var sw = el('div', { class: 'ldsp-swatch' }, [el('span', { class: 'ldsp-swatch__chip', style: 'background:' + c.hex })]);
        var nameEl = el('button', { class: 'ldsp-swatch__name', type: 'button', title: 'Tap to rename', text: c.name || c.hex });
        nameEl.addEventListener('click', function () {
          var inp = el('input', { class: 'ldsp-swatch__edit', type: 'text', value: c.name || '', 'aria-label': 'Colour name', maxlength: '32' });
          function commit() { var v = (inp.value || '').trim(); c.name = v || (FD.nameOf ? FD.nameOf(c.hex) : ''); FD.writeDesign(b.id, d); }
          inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); inp.blur(); } else if (e.key === 'Escape') { inp.value = c.name || ''; inp.blur(); } });
          inp.addEventListener('blur', commit);
          sw.replaceChild(inp, nameEl); inp.focus(); inp.select();
        });
        sw.appendChild(nameEl);
        sw.appendChild(el('span', { class: 'ldsp-swatch__hex', text: c.hex }));
        var rm = el('button', { class: 'ldsp-swatch__rm', type: 'button', 'aria-label': 'Remove colour', html: '&times;' });
        rm.addEventListener('click', function () { d.palette.splice(i, 1); FD.writeDesign(b.id, d); });
        sw.appendChild(rm);
        pal.appendChild(sw);
      });
    } else {
      pal.appendChild(el('span', { class: 'ldsp-palette__empty', text: 'no colours yet' }));
    }
    kids.push(pal);
    /* the draggable spectrum, toggled open by "+ add colour" */
    var addBtn = el('button', { class: 'ldsp-cf-add', type: 'button' }, ['+ add colour']);
    var pickHost = el('div', { class: 'ldsp-cpick-host' });
    pickHost.hidden = true;
    addBtn.addEventListener('click', function () {
      if (pickHost.hidden) {
        if (!pickHost.firstChild) {
          pickHost.appendChild(colourSpectrum(function (hex) {
            d.palette.push({ hex: hex, name: FD.nameOf ? FD.nameOf(hex) : '' });   /* named on arrival */
            FD.writeDesign(b.id, d);   /* store event → full re-render, picker resets */
          }));
        }
        pickHost.hidden = false;
        addBtn.textContent = 'close';
      } else {
        pickHost.hidden = true;
        addBtn.textContent = '+ add colour';
      }
    });
    kids.push(addBtn);
    kids.push(pickHost);

    /* ---- finishing & décor work (2026-09-20, Mariya) ----
       labour that takes real time so the Planner reserves it, priced or not.
       Priced décor (flowers/painting/…) is set in Cost & price and plans
       itself, so this is for the extra, unpriced work. */
    d.labour = Array.isArray(d.labour) ? d.labour : [];
    kids.push(el('div', { class: 'ldsp-subhead', text: 'Finishing & décor work' }));
    kids.push(el('div', { class: 'ldsp-body__note', text: 'Flag design work that takes real time so the Planner reserves it, even if you don’t charge for it. Sugar flowers, painting, sculpting and chocolate décor are set in Cost & price and already planned.' }));
    var LBANDS = [{ id: 'light', label: 'light · ~1 hr' }, { id: 'medium', label: 'medium · ~half a day' }, { id: 'heavy', label: 'heavy · ~full day' }];
    var lwrap = el('div', { class: 'ldsp-labour' });
    if (d.labour.length) {
      d.labour.forEach(function (it, i) {
        var chip = el('div', { class: 'ldsp-labour__item' }, [
          el('span', { class: 'ldsp-labour__lbl', text: it.label }),
          el('span', { class: 'ldsp-labour__band', text: (it.band || 'medium') })
        ]);
        var rmL = el('button', { class: 'ldsp-labour__rm', type: 'button', 'aria-label': 'Remove', html: '&times;' });
        rmL.addEventListener('click', function () { d.labour.splice(i, 1); FD.writeDesign(b.id, d); });
        chip.appendChild(rmL);
        lwrap.appendChild(chip);
      });
    } else {
      lwrap.appendChild(el('span', { class: 'ldsp-labour__empty', text: 'nothing flagged yet' }));
    }
    kids.push(lwrap);
    var pres = el('div', { class: 'ldsp-labour__presets' });
    (FD.labourPresets || []).forEach(function (p) {
      if (d.labour.some(function (x) { return x.id === p.id; })) return;
      var pc = el('button', { class: 'ldsp-labour__preset', type: 'button', text: '＋ ' + p.label });
      pc.addEventListener('click', function () { d.labour.push({ id: p.id, label: p.label, band: p.band }); FD.writeDesign(b.id, d); });
      pres.appendChild(pc);
    });
    kids.push(pres);
    /* the custom entry stays folded behind a small "+ add your own" until
       tapped (Mariya, 2026-09-21) */
    var lMore = el('button', { class: 'ldsp-labour__more', type: 'button', text: '＋ add your own' });
    var lAdd = el('div', { class: 'ldsp-labour__add' });
    lAdd.hidden = true;
    var lName = el('input', { class: 'ldsp-input ldsp-labour__name', type: 'text', placeholder: 'e.g. hand-lettering', maxlength: '60' });
    var lBand = el('select', { class: 'ldsp-labour__bandsel', 'aria-label': 'How much time it takes' });
    LBANDS.forEach(function (bd) { var o = el('option', { value: bd.id, text: bd.label }); if (bd.id === 'medium') o.selected = true; lBand.appendChild(o); });
    var lAddBtn = el('button', { class: 'ldsp-open ldsp-open--ghost ldsp-labour__addbtn', type: 'button', text: 'add' });
    function addLabour() {
      var lbl = (lName.value || '').trim(); if (!lbl) return;
      d.labour.push({ id: 'cust-' + Date.now().toString(36), label: lbl, band: lBand.value || 'medium' });
      FD.writeDesign(b.id, d);
    }
    lAddBtn.addEventListener('click', addLabour);
    lName.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); addLabour(); } });
    lMore.addEventListener('click', function () {
      lAdd.hidden = !lAdd.hidden;
      lMore.textContent = lAdd.hidden ? '＋ add your own' : 'close';
      if (!lAdd.hidden) { try { lName.focus(); } catch (e) { } }
    });
    lAdd.appendChild(lName); lAdd.appendChild(lBand); lAdd.appendChild(lAddBtn);
    kids.push(lMore);
    kids.push(lAdd);

    /* ---- inspiration images ---- */
    kids.push(el('div', { class: 'ldsp-subhead', text: 'Inspiration' }));
    var grid = el('div', { class: 'ldsp-inspo' });
    d.inspo.forEach(function (rec) {
      var tile = el('div', { class: 'ldsp-inspo__tile' + (d.hero === rec.id ? ' is-hero' : '') });
      var img = el('img', { class: 'ldsp-inspo__img', src: rec.thumb, alt: 'inspiration' });
      img.addEventListener('click', function () { openLightbox(img.src); });   /* full view */
      tile.appendChild(img);
      /* upgrade the synced cover thumb to the full local image where present */
      FD.displaySrc(b.id, rec).then(function (r) {
        if (r && r.src) img.src = r.src;
        if (r && !r.local) tile.classList.add('ldsp-inspo__tile--remote');
      }).catch(function () { });
      var bar = el('div', { class: 'ldsp-inspo__bar' });
      var heroB = el('button', { class: 'ldsp-inspo__act' + (d.hero === rec.id ? ' is-on' : ''), type: 'button', text: d.hero === rec.id ? 'hero' : 'set hero' });
      heroB.addEventListener('click', function () { d.hero = (d.hero === rec.id ? null : rec.id); FD.writeDesign(b.id, d); });
      var rmB = el('button', { class: 'ldsp-inspo__act ldsp-inspo__act--rm', type: 'button', 'aria-label': 'Remove photo', html: '&times;' });
      rmB.addEventListener('click', function () {
        try { FD.remove(b.id, rec); } catch (e) { }
        d.inspo = d.inspo.filter(function (x) { return x.id !== rec.id; });
        if (d.hero === rec.id) d.hero = null;
        FD.writeDesign(b.id, d);
      });
      bar.appendChild(heroB); bar.appendChild(rmB);
      tile.appendChild(bar);
      grid.appendChild(tile);
    });
    if (d.inspo.length < FD.MAX_PER_FILE) {
      var addImg = el('label', { class: 'ldsp-inspo__add' }, [el('span', { text: '＋ add photo' })]);
      var fileIn = el('input', { type: 'file', accept: 'image/*', class: 'ldsp-cf-add__input' });
      fileIn.addEventListener('change', function () {
        var f = fileIn.files && fileIn.files[0]; if (!f) return;
        addImg.classList.add('is-busy');
        FD.attach(b.id, f).then(function (rec) {
          d.inspo.push(rec);
          if (!d.hero) d.hero = rec.id;   /* the first photo becomes the hero */
          FD.writeDesign(b.id, d);
          showToast('Photo added. It stays on this device; a small cover syncs to your other devices.');
        }).catch(function () { addImg.classList.remove('is-busy'); showToast('Could not add that image'); });
      });
      addImg.appendChild(fileIn);
      grid.appendChild(addImg);
    }
    kids.push(grid);
    if (d.inspo.length) {
      var extract = el('button', { class: 'ldsp-open ldsp-open--ghost', type: 'button', text: 'Pull a palette from the photo →' });
      extract.addEventListener('click', function () {
        var rec = d.inspo.filter(function (x) { return x.id === d.hero; })[0] || d.inspo[0];
        FD.paletteFrom(rec.thumb).then(function (cols) { d.palette = cols; FD.writeDesign(b.id, d); showToast('Palette pulled from the photo'); }).catch(function () { showToast('Could not read that photo'); });
      });
      kids.push(extract);
    }
    kids.push(el('div', { class: 'ldsp-body__note', text: 'Photos stay on the device that added them, and a small cover syncs so every device shows the file. The palette always syncs.' }));
    return el('div', { class: 'ldsp-cf' }, kids);
  }

  function structBody(b, isCake) {
    var SC = window.LAYERD && window.LAYERD.structureCore;
    var C = window.LAYERD && window.LAYERD.cakeCore;
    if (!SC || !SC.plan) return null;
    /* UX 2026-09-08: Quick tools is "just the math" — read the scratch tiers,
       never the active booking (readCake prefers the active booking, which
       leaked its sizes + a "reconfirm structure" prompt into the standalone
       page). The confirm block below is also gated to the cake path. */
    var rc = isCake ? (F.readCake ? F.readCake() : { tiers: [] })
                    : (F.readScratch ? F.readScratch() : { tiers: [] });
    var tallFrom = (SC.DEFAULT_RULES && SC.DEFAULT_RULES.tallFromIn) || 6;
    /* structureCore expects tiers BASE-FIRST (index 0 = largest = base). A cake
       file stores its tierSpec in entry order, so sort here — the same defensive
       sort the standalone Structure tool and the Size drawing (renderStack) both
       do. Without it the elevation drew upside down and flagged false "not
       smaller than below" warnings when tiers were entered small-to-large. */
    var tiers = (rc.tiers || []).map(function (t) {
      return { d: +t.d || 6, shape: t.shape === 'square' ? 'square' : (t.shape === 'heart' ? 'heart' : 'round'), faux: !!t.faux, tall: (+t.h || 4) >= tallFrom };
    }).sort(function (a, b) { return (b.d || 0) - (a.d || 0); });
    if (!tiers.length) return el('div', { class: 'ldsp-body__note', text: 'Size the cake first. Structure works out the dowels and boards from the tiers.' });
    /* free/visitor see structure for two tiers and below (same cap as the
       Structure tool's free maxTiers 2); 3+ tiers is a Pro plan. */
    var pro = tierNow() === 'premium' || isAcademy();
    if (!pro && tiers.length > 2) {
      return el('div', { class: 'ldsp-sb' }, [
        el('div', { class: 'ldsp-locked-note', text: 'Free covers the dowel and board plan for two tiers and below. This cake has ' + tiers.length + ' tiers.' }),
        el('a', { class: 'ldsp-open', href: proUrl() }, ['Unlock 3+ tier structure with the Toolkit →'])
      ]);
    }
    var premium = (window.LAYERD.premium && window.LAYERD.premium.structure) || null;
    var inch = (C && C.sizeLabel) ? C.sizeLabel : function (n) { return n + '″'; };
    var p = SC.plan(tiers, { premium: premium, inch: inch });
    function matLabel(m) { if (premium && premium.labels && premium.labels[m]) return premium.labels[m]; return { wooden: '¼″ wooden dowels', straws: 'heavy-duty straws' }[m] || (m + ' dowels'); }

    var kids = [];
    /* the build, from the side — the SAME side elevation the Structure tool
       draws, with the real dowels shown (SC.elevation). The full tier-by-tier
       illustrations live in the Structure tool, reached by the door below. */
    try {
      var svg = SC.elevation ? SC.elevation(tiers, { premium: premium }) : '';
      if (svg) { var ev = el('div', { class: 'ldsp-cake ldsp-cake--struct', html: svg }); kids.push(ev); }
    } catch (eSv) { }
    if (p.board) kids.push(el('div', { class: 'ldsp-rows' }, [row('Base board', inch(p.board.baseSize) + ' ' + p.board.baseShape + (p.board.doubled ? ' · doubled drum' : ''))]));
    var dl = el('div', { class: 'ldsp-rows' });
    p.rows.forEach(function (r) {
      var val = r.dowels ? (r.dowels.count + ' × ' + matLabel(r.dowels.material) + (r.dowels.inner ? ' (+ inner ring)' : '')) : r.noReason;
      dl.appendChild(row(inch(r.tier.d) + ' ' + r.role, val));
    });
    kids.push(dl);
    kids.push(el('div', { class: 'ldsp-body__note', text: 'Plus one central dowel through the whole stack.' + (p.board && p.board.doubleMandatory ? ' The doubled base drum is mandatory here (8″+ base).' : '') }));
    (p.warnings || []).forEach(function (wn) { kids.push(el('div', { class: 'ldsp-locked-note', text: wn })); });
    /* confirm from here (step 3c): saving the reviewed plan IS the structure
       approval, same as the Structure tool's own save — it sets the green tick
       and writes the hardware list the Planner shops from. Serialises the SAME
       shared-engine plan shown above; no structure math is redone here. A later
       size change resets structureConfirmed (the cakefile layer owns that). */
    if (isCake && b && F.updateBooking) {
      var confirmed = pred('structureDone', b);
      function hardwareLines() {
        var out = [];
        if (p.board) out.push('1 × ' + inch(p.board.baseSize) + ' ' + p.board.baseShape + ' drum' + (p.board.doubled ? ' (doubled)' : ''));
        var tally = {};
        p.rows.forEach(function (r) {
          if (!r.dowels) return;
          var lbl = matLabel(r.dowels.material);
          tally[lbl] = (tally[lbl] || 0) + r.dowels.count;
          if (r.dowels.inner) { var il = matLabel('wooden'); tally[il] = (tally[il] || 0) + r.dowels.inner; }
        });
        Object.keys(tally).forEach(function (k) { out.push(tally[k] + ' × ' + k); });
        out.push('1 × central dowel');
        return out;
      }
      if (confirmed) kids.push(el('div', { class: 'ldsp-body__note', text: 'Structure confirmed. Re-confirm if the tiers change.' }));
      /* UX 2026-09-07: confirming IS this step's job, so it gets the filled
         button; the door to the full Structure tool below it goes ghost. */
      kids.push(el('button', { class: 'ldsp-open ldsp-open--cta', type: 'button', onclick: function () {
        F.updateBooking(b.id, function (bk) {
          bk.hardwareList = { lines: hardwareLines(), tierCount: tiers.length, at: (new Date()).toISOString().slice(0, 10) };
          bk.structureConfirmed = true;
        });
        /* UX 2026-09-08: the store re-render shows the confirmed note + green
           tick on a first confirm, but re-confirming an already-confirmed cake
           is idempotent and looked like nothing happened — a toast makes it clear. */
        showToast(confirmed ? 'Structure re-confirmed' : 'Structure confirmed');
      } }, [confirmed ? 'Re-confirm structure' : 'Confirm structure']));
    }
    return el('div', { class: 'ldsp-sb' }, kids);
  }

  /* native Quote step: the client-facing summary + copy + the payment gate
     (mark paid → confirm booking → production unlocks). Reads the numbers the
     other steps produced; nothing re-entered. */
  function setStatus(b, status) { if (F.updateBooking) F.updateBooking(b.id, function (x) { x.status = status; }); }
  /* ---- archive (2026-09-14, Mariya: "yes, auto-archive + manual archive") ----
     A cake leaves the active list once it is DELIVERED or its event date has
     PASSED, so the list is always the work still ahead. archivedFrom remembers
     the status so Restore puts it back; keepActive stops auto-archive from
     grabbing a cake she has deliberately restored. */
  function todayIsoLocal() {
    var n = new Date();
    return n.getFullYear() + '-' + ('0' + (n.getMonth() + 1)).slice(-2) + '-' + ('0' + n.getDate()).slice(-2);
  }
  function archiveBooking(b) {
    if (!F.updateBooking) return;
    F.updateBooking(b.id, function (x) {
      if (x.status !== 'archived') { x.archivedFrom = x.status || 'inquiry'; x.status = 'archived'; }
      x.keepActive = false;
    });
    render();
  }
  function restoreBooking(b) {
    if (!F.updateBooking) return;
    F.updateBooking(b.id, function (x) {
      x.status = x.archivedFrom || 'booked';
      delete x.archivedFrom; delete x.autoArchived;
      x.keepActive = true;   /* she pulled it back — don't auto-archive it again */
    });
    render();
  }
  /* runs ONCE per load, before the first render and before onChange is wired, so
     the updateBooking writes here never loop back into a re-render. */
  var autoArchiveRan = false;
  function autoArchive() {
    if (autoArchiveRan || !F.readStore || !F.updateBooking) return;
    autoArchiveRan = true;
    var today = todayIsoLocal();
    var store = F.readStore() || {};
    (store.bookings || []).forEach(function (b) {
      if (!b || b.status === 'archived' || b.keepActive) return;
      var past = !!(b.date && b.date < today);
      if (b.status === 'delivered' || past) {
        F.updateBooking(b.id, function (x) {
          if (x.status === 'archived' || x.keepActive) return;
          x.archivedFrom = x.status || 'inquiry';
          x.status = 'archived';
          x.autoArchived = true;
        });
      }
    });
  }
  function markPaid(b) {
    /* UX 2026-09-07: the button is disabled (with a hint) when there's no date,
       so this is just a guard now — no native alert. */
    if (!b.date) return;
    setStatus(b, 'booked');   /* fires layerd:cakefile → re-render → production unlocks */
  }
  function quoteSummaryText(b, money) {
    var C = window.LAYERD && window.LAYERD.cakeCore;
    var inch = (C && C.sizeLabel) ? C.sizeLabel : function (n) { return n + '″'; };
    var rc = F.readCake ? F.readCake() : { tiers: [] };
    var real = (rc.tiers || []).filter(function (t) { return !t.faux; });
    var shape = (real[0] && real[0].shape) ? real[0].shape : 'round';
    var stack = real.map(function (t) { return inch(t.d); }).join(' + ');
    var lines = [];
    lines.push(b.name || 'Cake quote');
    if (b.date) lines.push(prettyDate(b.date).replace(' ›', ''));
    lines.push((stack ? stack + ' ' + shape + ' cake' : 'cake') + (money.servings ? ' · ' + money.servings + ' servings' : ''));
    lines.push('Quote: ' + fmtMoney(money.quote, true) + (money.chargeSv != null ? ' (' + fmtMoney(money.chargeSv) + ' per serving)' : ''));
    lines.push('LAYER’D Cakes');
    return lines.join('\n');
  }
  function quoteBody(b, money) {
    var kids = [];
    if (!(money && money.quote != null)) {
      kids.push(el('div', { class: 'ldsp-body__note', text: 'Price the cake in Cost & price first. The quote sheet reads those numbers, nothing re-entered.' }));
      return el('div', { class: 'ldsp-sb' }, kids);
    }
    var C = window.LAYERD && window.LAYERD.cakeCore;
    var inch = (C && C.sizeLabel) ? C.sizeLabel : function (n) { return n + '″'; };
    var real = ((F.readCake ? F.readCake().tiers : []) || []).filter(function (t) { return !t.faux; });
    var stack = real.map(function (t) { return inch(t.d); }).join(' + ');
    /* UX 2026-09-14 (Mariya: the Quote step "feels like a word block". Present it
       as a MINI of Pricing's bottom quote card — an outlined, filled panel that
       lifts off the studio ground, the quote as the figure, the details as rows
       beneath). Same vocabulary as .ldp-result-total, spine tokens. */
    var qcard = el('div', { class: 'ldsp-quotecard' });
    qcard.appendChild(el('div', { class: 'ldsp-qc__head' }, [
      el('div', { class: 'ldsp-qc__headl' }, [
        el('span', { class: 'ldsp-qc__eyebrow', text: 'Quote' }),
        el('span', { class: 'ldsp-qc__big', text: fmtMoney(money.quote, true) })
      ]),
      (money.chargeSv != null ? el('div', { class: 'ldsp-qc__headr' }, [
        el('span', { class: 'ldsp-qc__per', text: fmtMoney(money.chargeSv) }),
        el('span', { class: 'ldsp-qc__persub', text: 'per serving · ' + money.servings + ' servings' })
      ]) : null)
    ].filter(Boolean)));
    qcard.appendChild(el('div', { class: 'ldsp-rows' }, [
      row('For', b.name || '—'),
      b.date ? row('Event', prettyDate(b.date).replace(' ›', '')) : null,
      stack ? row('Cake', stack + ' ' + ((real[0] && real[0].shape) || 'round')) : null,
      (money.chargeSv == null ? row('Servings', String(money.servings)) : null)
    ].filter(Boolean)));
    if (money.stale) qcard.appendChild(el('div', { class: 'ldsp-qc__flag', text: 'Numbers changed since this was priced. Re-price.' }));
    kids.push(qcard);

    var copyBtn = el('button', { class: 'ldsp-open ldsp-open--ghost', type: 'button' }, ['Copy quote summary']);
    copyBtn.addEventListener('click', function () {
      var txt = quoteSummaryText(b, money);
      var done = function () { copyBtn.textContent = 'Copied ✓'; setTimeout(function () { copyBtn.textContent = 'Copy quote summary'; }, 1600); };
      try { navigator.clipboard.writeText(txt).then(done, done); } catch (e) { done(); }
    });
    kids.push(copyBtn);

    if (!isPaid(b)) {
      if (!b.date) {
        /* UX 2026-09-07: disabled with a hint (was an alert on click) — a booking
           needs a date before it can be confirmed, so the plan can count back. */
        kids.push(el('div', { class: 'ldsp-locked-note', text: 'Add the event date first, from the booking header up top, so the production plan can count back from it. Then you can mark this paid.' }));
        kids.push(el('button', { class: 'ldsp-open ldsp-open--cta', type: 'button', disabled: 'disabled', 'aria-disabled': 'true' }, ['Mark paid · confirm booking']));
      } else {
        kids.push(el('div', { class: 'ldsp-locked-note', text: 'When the client accepts and pays the deposit, mark it paid. That confirms the booking and unlocks Recipes and the Planner.' }));
        kids.push(el('button', { class: 'ldsp-open ldsp-open--cta', type: 'button', onclick: function () { markPaid(b); } }, ['Mark paid · confirm booking']));
      }
    } else {
      kids.push(el('div', { class: 'ldsp-rows' }, [row('Status', 'Booked · production unlocked')]));
      kids.push(el('button', { class: 'ldsp-open ldsp-open--ghost', type: 'button', onclick: function () { setStatus(b, 'quoted'); } }, ['Revert to unpaid']));
    }
    return el('div', { class: 'ldsp-sb' }, kids);
  }

  function stepBody(st, b, money, isCake, s) {
    var kids = [];
    var id = b ? b.id : null;
    if (s.locked) {
      kids.push(el('div', { class: 'ldsp-locked-note', text: 'Unlocks once the quote is accepted and the booking is confirmed. Recipes and the production plan come after the tasting.' }));
      return el('div', { class: 'ldsp-body' }, kids);
    }
    if (st.id === 'size') {
      var sb = sizeBuilder(b, isCake);
      if (sb) kids.push(sb);
      else kids.push(el('div', { class: 'ldsp-body__note', text: 'The full Serving engine, usable on its own. Wilton slice, round and square.' }));
    } else if (st.id === 'structure') {
      var stb = structBody(b, isCake);
      if (stb) kids.push(stb);
      kids.push(el('div', { class: 'ldsp-body__note', text: 'Same engine as the Structure tool. Open it for the full tier-by-tier build illustrations. Feeds the Planner shopping list when saved.' }));
    } else if (st.id === 'cost') {
      if (isCake && b) {
        if (money && money.priced) {
          /* r222 (Mariya): drop the Quote total here — it duplicates the Quote
             step's card below. This step is the per-serving cost/charge only. */
          kids.push(el('div', { class: 'ldsp-rows' }, [
            row('Costs you', fmtMoney(money.costSv) + '/sv'),
            row('You charge', fmtMoney(money.chargeSv) + '/sv')
          ]));
        }
        kids.push(el('div', { class: 'ldsp-body__note', text: (money && money.priced) ? 'The full quote (cover, margin, elements, market and tax) opens in the pricing tool. Your numbers flow straight back to the summary bar.' : 'Price this cake: cover, cost, margin, elements, market and tax. Opens in the pricing tool, and the quote flows back to the summary bar here.' }));
        kids.push(el('a', { class: 'ldsp-open', href: doorHref('pricing', b.id) }, [(money && money.priced) ? 'Edit the quote in Pricing →' : 'Price this cake in Pricing →']));
        return el('div', { class: 'ldsp-body' }, kids);
      }
      kids.push(el('div', { class: 'ldsp-body__note', text: 'Price a cake: cover, cost, margin, elements, market and tax, all in one quote.' }));
    } else if (st.id === 'quote') {
      if (isCake && b) {
        kids.push(quoteBody(b, money));
        kids.push(el('a', { class: 'ldsp-open ldsp-open--ghost', href: doorHref('pricing', b.id) + '#print' }, ['Open the full quote sheet · print / PDF →']));
        return el('div', { class: 'ldsp-body' }, kids);   /* own door above; skip the generic one */
      }
      kids.push(el('div', { class: 'ldsp-body__note', text: 'The client-facing quote sheet. It reads the numbers from the steps above; once accepted, the production steps unlock.' }));
    } else if (st.id === 'recipes') {
      if (isCake && b) {
        /* UX 2026-09-07 (design pass): the flavour for each tier, plus the batch
           amounts per component. Everything is read from the shared store (the
           per-tier flavour on tierSpec, the grams saved by Batch Math into
           b.batchSheet). No tool math is redone here. */
        var C2 = window.LAYERD && window.LAYERD.cakeCore;
        var inchR = (C2 && C2.sizeLabel) ? C2.sizeLabel : function (n) { return n + '″'; };
        var rc2 = F.readCake ? F.readCake() : { tiers: [] };
        var realTiers = (rc2.tiers || []).filter(function (t) { return !t.faux; });
        if (realTiers.length) {
          var flav = el('div', { class: 'ldsp-rows' });
          realTiers.forEach(function (t, i) {
            var name = (t.flavour || '').trim();
            flav.appendChild(row('Tier ' + (i + 1) + ' · ' + inchR(t.d) + ' ' + (t.shape || 'round'), name || 'flavour not set'));
          });
          kids.push(el('div', { class: 'ldsp-subhead', text: 'Flavours' }));
          kids.push(flav);
          /* UX 2026-09-08: the Recipes step now doors to the Recipe Library
             (where flavours are actually SET / written to tierSpec), not only to
             Batch Math — setting flavours was previously unreachable from here. */
          var anyFlav = realTiers.some(function (t) { return (t.flavour || '').trim(); });
          kids.push(el('a', { class: 'ldsp-open', href: doorHref('recipe-library', b.id) }, [anyFlav ? 'Edit flavours in the Recipe Library →' : 'Set the flavours in the Recipe Library →']));
        }
        /* the grams per component, from Batch Math's saved sheet */
        var bs = b.batchSheet || {};
        function outOf(k) { return (bs[k] && bs[k].outputs) || null; }
        function grams(g) { return (g != null && g > 0) ? (Math.round(g).toLocaleString() + ' g') : 'not worked out'; }
        kids.push(el('div', { class: 'ldsp-subhead', text: 'Batch math' }));
        if (pred('batchHasFigures', b)) {
          var ct = outOf('ct'), fl = outOf('fl'), ga = outOf('ga'), bc = outOf('bc');
          /* sponge is stored as batch/pan counts, never a gram weight */
          var spongeB = ct ? (ct.batches || ct.batchesQ || 0) : 0;
          kids.push(el('div', { class: 'ldsp-rows' }, [
            row('Sponge', spongeB ? (spongeB + (spongeB === 1 ? ' batch' : ' batches')) : 'not worked out'),
            row('Fillings', grams(fl && fl.total)),
            row('Ganache', grams(ga && ga.total)),
            row('Buttercream', grams(bc && bc.total))
          ]));
          if (pred('batchIsStale', b)) {
            kids.push(el('div', { class: 'ldsp-locked-note', text: 'The cake changed size since these were worked out. Re-run to update the amounts.' }));
            kids.push(el('a', { class: 'ldsp-open', href: batchAutoHref(b) }, ['Re-run the batch math →']));
          }
          kids.push(el('a', { class: 'ldsp-open ldsp-open--ghost', href: doorHref('batch', b.id) }, ['Fine-tune in Batch Math →']));
        } else {
          /* UX 2026-09-11: the overlooked step. One tap works it all out with the
             file's defaults (no trip into the tool); the tool is there to adjust. */
          kids.push(el('div', { class: 'ldsp-todo' }, [el('span', { class: 'ldsp-todo__mk', text: '○' }), el('span', { text: 'Not worked out yet' })]));
          kids.push(el('div', { class: 'ldsp-body__note', text: 'Sponge, fillings, ganache and buttercream in grams, plus the shopping list. Work it out from the cake in one tap.' }));
          kids.push(el('a', { class: 'ldsp-open', href: batchAutoHref(b) }, ['Work out the batch math →']));
          kids.push(el('a', { class: 'ldsp-open ldsp-open--ghost', href: doorHref('batch', b.id) }, ['Or set it by hand in Batch Math →']));
        }
        return el('div', { class: 'ldsp-body' }, kids);
      }
      kids.push(el('div', { class: 'ldsp-body__note', text: 'Flavours and batch math: how much of each recipe a cake needs.' }));
    } else if (st.id === 'planner') {
      if (isCake && b) {
        /* UX 2026-09-21 (Mariya): a neat right-aligned table by default; the
           editable date + delivery controls live behind "edit details". */
        var canEditP = !!(F && F.updateBooking);
        var driveVal = (b.drive != null && b.drive !== '') ? b.drive : 30;
        var cd = null;
        if (b.date) {
          var evD = new Date(b.date + 'T00:00:00');
          var td = new Date(); td.setHours(0, 0, 0, 0);
          var days = Math.round((evD - td) / 86400000);
          cd = isNaN(days) ? '—' : days < 0 ? 'past' : days === 0 ? 'today' : days === 1 ? 'tomorrow' : days + ' days out';
        }
        if (!(canEditP && plannerEditOpen)) {
          var srows = [];
          srows.push(row('Event', b.date ? prettyDate(b.date).replace(' ›', '') : 'not set'));
          if (cd) srows.push(row('Countdown', cd));
          srows.push(row('Handover', b.pickup ? 'Pickup' : 'Delivery'));
          if (!b.pickup) {
            if ((b.venue || '').trim()) srows.push(row('Venue', b.venue.trim()));
            srows.push(row('Drive', driveVal + ' min'));
          }
          kids.push(el('div', { class: 'ldsp-rows' }, srows));
          if (canEditP) {
            var eBtn = el('button', { class: 'ldsp-labour__more', type: 'button', text: 'edit details ›' });
            eBtn.addEventListener('click', function () { plannerEditOpen = true; render(); });
            kids.push(eBtn);
          }
        } else {
          /* the editable panel. Field edits persist WITHOUT a re-render (so
             the panel doesn't collapse mid-edit); only the pickup toggle
             re-renders, to swap the venue/drive fields in and out. */
          var dWrap = el('label', { class: 'ldsp-field' }, [el('span', { class: 'ldsp-field__lbl', text: 'Event date' })]);
          var evIn = el('input', { class: 'ldsp-input', type: 'date', value: b.date || '', 'aria-label': 'Event date' });
          evIn.addEventListener('change', function () { F.updateBooking(b.id, function (x) { x.date = evIn.value || ''; }); });
          dWrap.appendChild(evIn);
          kids.push(dWrap);
          var del = el('div', { class: 'ldsp-delivery' });
          del.appendChild(el('span', { class: 'ldsp-field__lbl', text: 'Pickup or delivery' }));
          var seg = el('div', { class: 'ldsp-seg', role: 'group', 'aria-label': 'Pickup or delivery' });
          function segBtn(label, on, pk) {
            var sb = el('button', { class: 'ldsp-seg__b' + (on ? ' is-on' : ''), type: 'button', text: label, 'aria-pressed': on ? 'true' : 'false' });
            sb.addEventListener('click', function () { if (!!b.pickup === pk) return; F.updateBooking(b.id, function (x) { x.pickup = pk; }); render(); });
            return sb;
          }
          seg.appendChild(segBtn('Delivery', !b.pickup, false));
          seg.appendChild(segBtn('Pickup', !!b.pickup, true));
          del.appendChild(seg);
          if (!b.pickup) {
            var vLbl = el('label', { class: 'ldsp-field' }, [el('span', { class: 'ldsp-field__lbl', text: 'Venue / delivery location (optional)' })]);
            var vIn = el('input', { class: 'ldsp-input', type: 'text', value: b.venue || '', placeholder: 'e.g. The Grand Hall', maxlength: '80' });
            vIn.addEventListener('change', function () { F.updateBooking(b.id, function (x) { x.venue = (vIn.value || '').trim(); }); });
            vLbl.appendChild(vIn);
            del.appendChild(vLbl);
            var dLbl = el('label', { class: 'ldsp-field ldsp-delivery__drive' }, [el('span', { class: 'ldsp-field__lbl', text: 'Drive time' })]);
            var dRow = el('div', { class: 'ldsp-delivery__driverow' });
            var dIn = el('input', { class: 'ldsp-input ldsp-input--num', type: 'number', min: '0', step: '5', value: driveVal, 'aria-label': 'Drive time in minutes' });
            dIn.addEventListener('change', function () { F.updateBooking(b.id, function (x) { x.drive = Math.max(0, +dIn.value || 0); }); });
            dRow.appendChild(dIn);
            dRow.appendChild(el('span', { class: 'ldsp-delivery__min', text: 'min' }));
            dLbl.appendChild(dRow);
            del.appendChild(dLbl);
          } else {
            del.appendChild(el('div', { class: 'ldsp-field__hint' }, [el('span', { text: 'No drive, no on-site setup — the plan hands it over at the studio.' })]));
          }
          kids.push(del);
          var doneBtn = el('button', { class: 'ldsp-labour__more', type: 'button', text: 'done' });
          doneBtn.addEventListener('click', function () { plannerEditOpen = false; render(); });
          kids.push(doneBtn);
        }
        kids.push(el('div', { class: 'ldsp-body__note', text: 'The backwards production plan for this cake, counted from the event date.' }));
        kids.push(el('a', { class: 'ldsp-open', href: plannerHref(b) }, ['Open the Planner →']));
        /* UX 2026-09-10: the ingredient shopping list lives in the Planner now
           (Schedule / Shopping toggle), not Batch Math — hop straight to it. */
        kids.push(el('a', { class: 'ldsp-open ldsp-open--ghost', href: plannerShopHref(b) }, ['Shopping list →']));
        return el('div', { class: 'ldsp-body' }, kids);
      }
      kids.push(el('div', { class: 'ldsp-body__note', text: 'The backwards production plan, counted from the event date.' }));
    } else if (st.id === 'clientfile') {
      if (isCake && b) { kids.push(clientFileBody(b)); return el('div', { class: 'ldsp-body' }, kids); }
      kids.push(el('div', { class: 'ldsp-body__note', text: 'Inspiration images and the colour palette, kept on a cake file. Open a cake to build it.' }));
    }
    /* the door is ghost in Quick tools, and ghost on the Structure step in cake
       mode too (its filled button is Confirm structure, above). The old
       "Save into a cake file" button here only opened the tool, which is what
       the door already does, so it is gone; the quicknote explains saving. */
    var ghostDoor = !isCake || (st.id === 'structure' && b && F.updateBooking);
    /* 2026-10-11 (Mariya): the Open <tool> door is a pill now (--door), gold in
       every mode so it's easy to find; the ghost flag stays for any older styling */
    kids.push(el('a', { class: 'ldsp-open ldsp-open--door' + (ghostDoor ? ' ldsp-open--ghost' : ''), href: id ? doorHref(st.tool, id) : toolUrl(st.tool, id) }, ['Open ' + st.name + ' →']));
    return el('div', { class: 'ldsp-body' }, kids);
  }

  /* ---- render (responsive: mobile accordion / desktop rail + working column) ---- */
  var MQ = window.matchMedia ? window.matchMedia('(min-width: 900px)') : { matches: false, addEventListener: function () { }, addListener: function () { } };

  /* 2026-10-11 (Mariya, design canvas "Toolkit app: desktop workspace"): from
     1200px the Toolkit uses the whole screen. This cake = cake files | the open
     cake with every section open at once | coming up. Bookings = the month with
     the cakes written in the days | the pipeline. Tools = the tool list | the
     open tool. Below 1200px nothing changes. Same store, same step bodies, same
     row and calendar behaviour as every other width; only the arrangement differs. */
  var MQW = window.matchMedia ? window.matchMedia('(min-width: 1200px)') : { matches: false, addEventListener: function () { }, addListener: function () { } };
  function isWide() { return !!(MQ.matches && MQW.matches); }
  /* true while an embedded tool frame (Pricing / Batch Math / Planner) is on
     screen — so a store change it triggers refreshes the summary bar only,
     instead of a full render that would reload the frame and lose work. */
  var frameActive = false;
  var pendingUpsell = false;   /* free tier hit the one-file cap on a save attempt */
  /* UX 2026-09-07: ids mid-undo after a delete. The row hides at once but the
     file is only removed from the store when the toast lapses, so Undo needs no
     restore API. Value is the pending setTimeout handle. */
  var pendingDeletes = {};

  /* UX 2026-09-07: lightweight toast (undo affordance for delete). Lives on the
     body, outside the mount, so a re-render doesn't wipe it. */
  function showToast(msg, actionLabel, onAction) {
    var host = document.getElementById('ldsp-toast-host');
    if (!host) { host = el('div', { id: 'ldsp-toast-host', class: 'ldsp-toasts' }); (document.body || document.documentElement).appendChild(host); }
    var t = el('div', { class: 'ldsp-toast' }, [el('span', { class: 'ldsp-toast__msg', text: msg })]);
    if (actionLabel) {
      var a = el('button', { class: 'ldsp-toast__act', type: 'button' }, [actionLabel]);
      a.addEventListener('click', function () { removeToast(t); if (onAction) onAction(); });
      t.appendChild(a);
    }
    host.appendChild(t);
    t._life = setTimeout(function () { removeToast(t); }, 6000);
    return t;
  }
  function removeToast(t) { if (!t || !t.parentNode) return; try { clearTimeout(t._life); } catch (e) { } t.parentNode.removeChild(t); }

  /* UX 2026-09-07 (design pass): the slim top row is gone. The gear folds into
     the bottom bar's Account tab, which opens the settings + account view; the
     brand / get-the-app / account links live inside that view. */
  /* UX 2026-09-09 (Atelier direction, her call): each step carries a small line
     icon — sage when the step is done, muted ink when not, a padlock when locked.
     Same 18px box as the old tick/ring so nothing else in the row moves. */
  var STEP_ICONS = {
    size: '<rect x="2.5" y="6" width="13" height="6" rx="1"></rect><path d="M6 6v2.4M9 6v3M12 6v2.4"></path>',
    structure: '<rect x="3" y="10" width="12" height="4.5" rx="1"></rect><rect x="5.5" y="4.5" width="7" height="5" rx="1"></rect>',
    cost: '<path d="M9.2 2.6H14a1.4 1.4 0 0 1 1.4 1.4v4.8L8 16.2 1.8 10 9.2 2.6z"></path><circle cx="12" cy="6" r="1"></circle>',
    quote: '<rect x="4" y="2.5" width="10" height="13" rx="1.5"></rect><path d="M6.5 6.5h5M6.5 9.5h5M6.5 12.5h3"></path>',
    recipes: '<path d="M9 2.5v5M6 8.5c0 3 1.4 6 3 6s3-3 3-6c0-1-1.4-1.6-3-1.6S6 7.5 6 8.5z"></path>',
    planner: '<rect x="2.5" y="4" width="13" height="11.5" rx="1.5"></rect><path d="M2.5 8h13M6 2.5v3M12 2.5v3"></path>',
    clientfile: '<rect x="2.5" y="3.5" width="13" height="11" rx="1.5"></rect><circle cx="6.5" cy="7" r="1.3"></circle><path d="M15.5 12l-4-4-5.5 6"></path>'
  };
  function markEl(s, isCake, selected, st) {
    if (s.locked) return el('span', { class: 'ldsp-mark ldsp-mark--lock', html: '<svg viewBox="0 0 18 18" width="15" height="15" fill="none" stroke="rgba(42,33,56,.32)" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="8.2" width="10" height="6.6" rx="1.6"></rect><path d="M6 8.2V6.2a3 3 0 0 1 6 0v2"></path></svg>' });
    var paths = st && STEP_ICONS[st.id];
    if (!paths) return el('span', { class: 'ldsp-mark ldsp-mark--empty', html: '<svg viewBox="0 0 18 18" width="18" height="18" fill="none" aria-hidden="true"><circle cx="9" cy="9" r="6" stroke="rgba(42,33,56,.28)" stroke-width="1.3"></circle></svg>' });
    var done = isCake && s.done;
    /* UX 2026-09-11: an explicit ✓ badge on finished steps so the file reads as
       a checklist — what's done, and by absence what's still open. */
    var m = el('span', { class: 'ldsp-mark ' + (done ? 'ldsp-mark--done' : 'ldsp-mark--empty'), html:
      '<svg viewBox="0 0 18 18" width="18" height="18" fill="none" stroke="' + (done ? '#6F7D62' : 'rgba(42,33,56,.32)') + '" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + paths + '</svg>' });
    if (done) m.appendChild(el('span', { class: 'ldsp-mark__tick', 'aria-label': 'done', html: '<svg viewBox="0 0 12 12" width="9" height="9" fill="none" stroke="#FCFBF8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.3 5 8.6 9.5 3.6"></path></svg>' }));
    return m;
  }
  function emptyCard() {
    return el('div', { class: 'ldsp-empty' }, [
      el('div', { class: 'ldsp-empty__h', text: 'No cake open yet' }),
      el('div', { class: 'ldsp-empty__sub', text: 'A client file is the spine. Start one and every step, from sizing to the quote, lives on one screen. Or switch to Quick tools to use any tool on its own.' }),
      el('button', { class: 'ldsp-open ldsp-open--cta', type: 'button', onclick: startFile }, ['Start a cake file'])
    ]);
  }
  function quickHead() {
    /* UX 2026-09-09: new and visitor users land here first — a two-line intro
       and the directory, no tutorial. */
    var h = el('div', { class: 'ldsp-quickhead' }, [
      el('span', { class: 'ldsp-quickhead__eyebrow', text: 'Free · no account needed' }),
      el('span', { class: 'ldsp-quickhead__h', text: 'Tools' }),
      el('span', { class: 'ldsp-quickhead__sub', text: 'Every calculator, on its own. Save any result into a cake file to keep it.' })
    ]);
    h.appendChild(gearBtn());
    return h;
  }
  /* UX 2026-09-09: full-size photo view. Tapping the hero band or any inspo
     tile opens the image over the page, letterboxed to fit; tap anywhere,
     the ×, or Esc closes it. */
  function openLightbox(src) {
    if (!src) return;
    var ov = el('div', { class: 'ldsp-lightbox', role: 'dialog', 'aria-label': 'Cake photo' }, [
      el('img', { class: 'ldsp-lightbox__img', src: src, alt: '' }),
      el('button', { class: 'ldsp-lightbox__close', type: 'button', 'aria-label': 'Close', html: '&times;' })
    ]);
    function close() { if (ov.parentNode) ov.parentNode.removeChild(ov); document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    ov.addEventListener('click', close);
    document.addEventListener('keydown', onKey);
    (document.body || document.documentElement).appendChild(ov);
  }

  /* UX 2026-09-10: the cakes you can flip between from the header — active files
     (never archived, never mid-undo), in date order so "next" is the next cake
     up. Two cakes on the same day sit next to each other. */
  function navBookings() {
    var store = F.readStore ? F.readStore() : { bookings: [] };
    return (store.bookings || [])
      .filter(function (x) { return x.status !== 'archived' && pendingDeletes[x.id] == null; })
      .sort(function (a, b) {
        var da = a.date || '9999-12-31', db = b.date || '9999-12-31';
        if (da !== db) return da.localeCompare(db);
        return (a.created || '').localeCompare(b.created || '') || String(a.id).localeCompare(String(b.id));
      });
  }
  /* prev / next through those cakes, shown only when there's more than one.
     Wraps around so you can keep flipping; lands each cake fully collapsed. */
  function cakeFlipNav(b) {
    var list = navBookings();
    if (list.length < 2) return null;
    var idx = -1;
    for (var i = 0; i < list.length; i++) { if (list[i].id === b.id) { idx = i; break; } }
    if (idx < 0) return null;
    function goTo(j) {
      var t = list[(j + list.length) % list.length];
      if (!t || !F.setActiveBooking) return;
      F.setActiveBooking(t.id, 'toolkit');
      ui.view = 'cake'; ui.mode = 'cake'; ui.open = null; saveUi(); render();
    }
    var prev = el('button', { class: 'ldsp-flip__btn', type: 'button', 'aria-label': 'Previous cake', title: 'Previous cake' }, ['‹']);
    prev.addEventListener('click', function () { goTo(idx - 1); });
    var next = el('button', { class: 'ldsp-flip__btn', type: 'button', 'aria-label': 'Next cake', title: 'Next cake' }, ['›']);
    next.addEventListener('click', function () { goTo(idx + 1); });
    return el('div', { class: 'ldsp-flip' }, [
      prev,
      el('span', { class: 'ldsp-flip__count', text: (idx + 1) + ' of ' + list.length }),
      next
    ]);
  }

  function bookHead(b) {
    /* UX 2026-09-07 (calm-minimal redesign): the approved mockup header —
       a gold "Active cake" eyebrow, the cake name in Cormorant, then one
       quiet sub-line carrying the date (→ Planner) and the prices note
       (→ settings). No right-hand chip, no filled boxes. */
    var eyebrow = el('div', { class: 'ldsp-bookhead__eyebrow', text: 'Active cake' });
    var nameBtn = el('button', { class: 'ldsp-bookhead__name', type: 'button', title: 'Rename this cake' }, [b.name || 'Untitled cake']);
    nameBtn.addEventListener('click', function () { startRename(b, nameBtn); });
    /* date: Planner link when set, an add-date affordance when not */
    var dateSlot = b.date
      ? el('a', { class: 'ldsp-datechip', href: plannerHref(b), title: 'Open this cake in the Planner' }, [prettyDate(b.date).replace(' ›', '')])
      : el('button', { class: 'ldsp-datechip ldsp-datechip--add', type: 'button', title: 'Add the event date' }, ['add event date']);
    if (!b.date) dateSlot.addEventListener('click', function () { startAddDate(b, dateSlot); });
    /* the prices note is always shown and always opens settings */
    var priceBtn = el('button', { class: 'ldsp-curchip', type: 'button', title: 'Currency & units' },
      ['prices in ' + curSymbol(curCode()) + ', ' + (unitsNow() === 'cm' ? 'cm' : 'inches')]);
    priceBtn.addEventListener('click', function () { markSettingsSeen(); ui.view = 'settings'; saveUi(); render(); });
    var subline = el('div', { class: 'ldsp-subline' }, [
      dateSlot,
      el('span', { class: 'ldsp-subline__sep', text: '·' }),
      priceBtn
    ]);
    var left = el('div', { class: 'ldsp-bookhead__l' }, [eyebrow, nameBtn, subline]);
    var head = el('div', { class: 'ldsp-bookhead' }, [left, gearBtn()]);
    /* UX 2026-09-08: the cake file's hero image — the chosen inspo photo (or the
       first one) as a soft band under the name. Tapping it opens the Client file
       step. Falls back silently to no band when there are no photos. */
    var FD = window.LAYERD && window.LAYERD.fileDesign;
    if (FD) {
      var dz = FD.readDesign(b);
      var heroRec = dz.inspo.length ? (dz.inspo.filter(function (x) { return x.id === dz.hero; })[0] || dz.inspo[0]) : null;
      if (heroRec) {
        /* UX 2026-09-09: the band no longer crops — object-fit:contain shows the
           whole (usually vertical) cake — and tapping it opens the full-size
           image in a lightbox (the local full-res blob once it has loaded). */
        var himg = el('img', { class: 'ldsp-hero__img', src: heroRec.thumb, alt: 'Cake photo' });
        /* UX 2026-09-10: an expand badge so the banner reads as tap-to-enlarge */
        var expand = el('span', { class: 'ldsp-hero__expand', 'aria-hidden': 'true', html: '<svg viewBox="0 0 20 20" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3h5v5M17 3l-6 6M8 17H3v-5M3 17l6-6"/></svg>' });
        var band = el('button', { class: 'ldsp-hero', type: 'button', 'aria-label': 'View the full cake photo' }, [himg, expand]);
        FD.displaySrc(b.id, heroRec).then(function (r) { if (r && r.src) himg.src = r.src; }).catch(function () { });
        band.addEventListener('click', function () { openLightbox(himg.src); });
        head.appendChild(band);
      }
    }
    return head;
  }
  /* UX 2026-09-07: inline rename (was window.prompt). Swaps the name for a text
     field in place; Enter or blur commits, Esc cancels. */
  function startRename(b, nameBtn) {
    var parent = nameBtn.parentNode; if (!parent) return;
    var input = el('input', { class: 'ldsp-input ldsp-inlineedit', type: 'text', value: b.name || 'Untitled cake', 'aria-label': 'Cake name' });
    parent.replaceChild(input, nameBtn);
    input.focus(); try { input.select(); } catch (e) { }
    var done = false;
    function commit() {
      if (done) return; done = true;
      var next = (input.value || '').trim();
      if (next && next !== b.name && F.updateBooking) F.updateBooking(b.id, function (bk) { bk.name = next; });
      render();
    }
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); commit(); }
      else if (e.key === 'Escape') { e.preventDefault(); done = true; render(); }
    });
    input.addEventListener('blur', commit);
  }
  /* UX 2026-09-07: add the event date inline from the booking header. */
  function startAddDate(b, chip) {
    var parent = chip.parentNode; if (!parent) return;
    var input = el('input', { class: 'ldsp-input ldsp-inlineedit ldsp-inlineedit--date', type: 'date', 'aria-label': 'Event date' });
    parent.replaceChild(input, chip);
    try { input.focus(); if (input.showPicker) input.showPicker(); } catch (e) { }
    var done = false;
    function commit() {
      if (done) return; done = true;
      var iso = input.value || '';
      if (iso && F.updateBooking) F.updateBooking(b.id, function (bk) { bk.date = iso; });
      render();
    }
    input.addEventListener('change', commit);
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.preventDefault(); done = true; render(); } });
    input.addEventListener('blur', commit);
  }
  /* the first non-locked step id, used as the safe default selection */
  function firstOpenable(b, money, isCake) {
    for (var i = 0; i < STEPS.length; i++) { if (!stepState(STEPS[i], b, money, isCake).locked) return STEPS[i].id; }
    return 'size';
  }

  function render() {
    var b = F.getActiveBooking ? F.getActiveBooking() : null;
    var money = F.readMoney ? F.readMoney() : null;
    if (ui.mode !== 'cake' && ui.mode !== 'quick') ui.mode = b ? 'cake' : 'quick';
    var isCake = ui.mode === 'cake';
    /* null = intentionally all-collapsed (mobile); only reset an INVALID
       non-null open step, so tapping an open header can close it. */
    if (ui.open !== null && !STEPS.some(function (s) { return s.id === ui.open; })) ui.open = 'size';
    if (ui.view === 'account') ui.view = 'settings';   /* migrate the old id */
    if (ui.view !== 'bookings' && ui.view !== 'settings' && ui.view !== 'newcake') ui.view = 'cake';
    /* UX 2026-09-07: no mandatory first-run gate. The workspace opens straight
       away (currency defaults to the storefront market); the "prices in X" chip
       in the top bar nudges setup until settings are saved once. */
    /* iframes are impossible on Shopify (storefront pages send X-Frame-Options
       DENY + CSP frame-ancestors 'none'), so the big tools open via a scoped
       door, not an embed. No live frame → always full-render on change. */
    frameActive = false;
    var frag = document.createDocumentFragment();
    /* UX 2026-09-07 (calm-minimal redesign): one centred single-column layout
       at every width — the composition the approved mockup is built on. Desktop
       just widens the reading column (see .is-desktop in the CSS); the old
       master-detail rail (renderDesktop) is retired so there is one layout to
       keep, and nothing changes shape between phone and desktop.
       NOTE: renderMobile is the `else` of this chain — it must NOT run for the
       bookings/settings/newcake views, or their bar renders twice (the second,
       "This cake" bar overlays the real one). */
    var wide = isWide();
    var wideView = wide && (ui.view === 'bookings' || ui.view === 'settings' || (ui.view === 'cake' && (!isCake || !!b)));
    if (ui.view === 'settings') { if (wide) renderSettingsWide(frag, b, money); else renderSettings(frag); }
    else if (ui.view === 'bookings') { if (wide) renderBookingsWide(frag, b); else renderBookings(frag, b); }
    else if (ui.view === 'newcake') renderNewCake(frag);
    else if (wide && isCake && b) renderCakeWide(frag, b, money);
    else if (wide && !isCake) renderToolsWide(frag, b, money);
    else renderMobile(frag, b, money, isCake);
    /* 2026-09-17 (Mariya: "there needs to be a very easy switch between the two
       platforms on the PWA, easy to see immediately"). The Academy spine already
       shows a gold "Toolkit →" on every view (learn-academy-spine.js header());
       this is the mirror. Academy members only - the Toolkit is a separate
       membership and non-members have no Academy to switch to. First child of
       frag so it sits at the very top of the reading column (and, on desktop,
       at the top of .ldsp-main after swap() lifts out the sidebar). */
    if (isAcademy()) frag.insertBefore(academySwitch(), frag.firstChild);
    mount.className = 'ld-toolkit' + (MQ.matches ? ' is-desktop' : '') + (wideView ? ' is-wide' : '');
    swap(frag);
    /* UX 2026-09-07 (finding 4): fill the embedded settings host with the shared
       component once it's in the DOM. Guarded so a page without the shared bundle
       (or a stale one) just shows the fallback link inside the host. */
    if (ui.view === 'settings') mountSharedSettings(0);
  }

  /* 2026-09-15 (Mariya: the account page's settings link redirected to the
     product page). The shared settings card fills the ldsp-setmount host, but
     learn-components.js can load AFTER the spine paints the settings view - and
     until it does, mountSettings is undefined and the host shows only its no-JS
     fallback link. Retry until the bundle is there, so the real card (and the
     Production-reminders card that rides its ld:settings-mounted event) lands
     every time and the fallback is never what she taps. */
  function mountSharedSettings(tries) {
    if (ui.view !== 'settings') return;                     /* navigated away */
    var host = document.querySelector('.ldsp-setmount[data-ld-settings]');
    if (!host || host.querySelector('.ld-settings')) return; /* gone, or already mounted */
    try {
      var CC = window.LAYERD && window.LAYERD.components;
      if (CC && CC.mountSettings) {
        CC.mountSettings();
        /* UX 2026-09-09: tell learn-reminders.js the panel exists so its card mounts too */
        window.dispatchEvent(new CustomEvent('ld:settings-mounted'));
      }
    } catch (e) { }
    if (!host.querySelector('.ld-settings') && (tries || 0) < 10) {
      setTimeout(function () { mountSharedSettings((tries || 0) + 1); }, 250);
    }
  }

  /* ---- Bookings: browse and open client files ---- */
  function statusLabel(s) {
    return ({ inquiry: 'Inquiry', quoted: 'Quoted', booked: 'Booked', production_ready: 'In production', delivered: 'Delivered', archived: 'Archived' })[s] || 'Inquiry';
  }
  /* UX 2026-09-08 (bookings restructure): one bookings row (open + delete-with-
     undo), shared by the Client-files list and the Calendar's month view. */
  function bkRowWrap(b, activeB) {
    var sv = F.servingsOfBooking ? F.servingsOfBooking(b) : 0;
    var meta = [b.date ? prettyDate(b.date).replace(' ›', '') : 'no date', sv ? sv + ' servings' : null].filter(Boolean).join(' · ');
    var isActive = activeB && activeB.id === b.id;
    var open = el('button', {
      class: 'ldsp-bkrow' + (isActive ? ' is-active' : ''), type: 'button',
      /* UX 2026-09-11: one tap from a booking lands on that cake's Design (client
         file) section, open — not the collapsed workspace that needed a 2nd tap. */
      onclick: function () { if (F.setActiveBooking) F.setActiveBooking(b.id, 'toolkit'); ui.view = 'cake'; ui.mode = 'cake'; ui.open = 'clientfile'; saveUi(); render(); }
    }, [
      el('span', { class: 'ldsp-bkrow__dot ldsp-c' + ((b.colorIndex || 0) % 8) }),
      el('span', { class: 'ldsp-bkrow__main' }, [
        el('span', { class: 'ldsp-bkrow__name', text: b.name || 'Untitled cake' }),
        el('span', { class: 'ldsp-bkrow__meta', text: meta })
      ]),
      el('span', { class: 'ldsp-bkrow__status ldsp-bkrow__status--' + (b.status || 'inquiry'), text: statusLabel(b.status) })
    ]);
    var del = el('button', {
      class: 'ldsp-bkdel', type: 'button', 'aria-label': 'Delete ' + (b.name || 'this cake'), title: 'Delete this cake file',
      onclick: function (ev) {
        ev.stopPropagation();
        var bid = b.id, bname = b.name || 'this cake';
        /* 2026-09-14 (Mariya): confirm before deleting a file. The undo toast
           below is a second safety net, but a delete shouldn't be one stray tap. */
        if (!window.confirm('Delete “' + bname + '”? This removes the cake file and its production plan.')) return;
        pendingDeletes[bid] = setTimeout(function () {
          if (pendingDeletes[bid] == null) return;
          delete pendingDeletes[bid];
          if (F.deleteBooking) F.deleteBooking(bid);
          render();
        }, 6000);
        showToast('Deleted “' + bname + '”', 'Undo', function () {
          if (pendingDeletes[bid] != null) { clearTimeout(pendingDeletes[bid]); delete pendingDeletes[bid]; }
          render();
        });
        render();
      }
    }, ['×']);
    /* 2026-09-14 (Mariya): manual archive / restore, beside delete. Archive is
       the soft "this one's done" move (delivered cakes and past dates also go on
       their own, see autoArchive); Restore pulls one back and pins it active. */
    var archived = b.status === 'archived';
    var arch = el('button', {
      class: 'ldsp-bkarch', type: 'button',
      'aria-label': (archived ? 'Restore ' : 'Archive ') + (b.name || 'this cake'),
      title: archived ? 'Restore to the active list' : 'Archive this cake',
      onclick: function (ev) { ev.stopPropagation(); if (archived) restoreBooking(b); else archiveBooking(b); }
    });
    arch.innerHTML = archived
      ? '<svg viewBox="0 0 20 20" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="12.5" width="14" height="3.5" rx="1"></rect><path d="M10 10.5V3.5"></path><path d="M7 6.5l3-3 3 3"></path></svg>'
      : '<svg viewBox="0 0 20 20" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="14" height="3.5" rx="1"></rect><path d="M4.5 7.5v7a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-7"></path><path d="M8 10.5h4"></path></svg>';
    return el('div', { class: 'ldsp-bkrow-wrap' }, [open, arch, del]);
  }

  function segBtn(label, on, onclick) {
    return el('button', { class: 'ldsp-seg__b' + (on ? ' is-on' : ''), type: 'button', 'aria-pressed': on ? 'true' : 'false', onclick: onclick }, [label]);
  }

  /* the Bookings calendar. calYM is the shown month ('YYYY-MM'); it lives in a
     module var so ‹ › nav survives re-renders but resets to the current month on
     a fresh load (the sensible landing). */
  var calYM = null;
  /* 2026-09-27 (Mariya: "the desktop version won't let me add a booking by
     clicking on the calendar date"). The day a baker taps on the calendar, handed
     to the new-cake form as its event date and consumed there. The Planner's old
     calendar did this (day-click -> booking prefill); it was lost when the
     calendar moved into the Studio on 2026-09-10. */
  var pendingNewDate = null;
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  function nowYM() { var n = new Date(); return n.getFullYear() + '-' + ('0' + (n.getMonth() + 1)).slice(-2); }
  function shiftYM(ym, delta) { var p = ym.split('-'); var d = new Date(+p[0], (+p[1] - 1) + delta, 1); return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2); }
  function statusDotClass(s) {
    if (s === 'booked' || s === 'production_ready') return 'is-booked';
    if (s === 'quoted') return 'is-quoted';
    return 'is-mut';
  }
  function calLegend(cls, label) { return el('span', { class: 'ldsp-cal__leg' }, [el('span', { class: 'ldsp-cal__dot ' + cls }), label]); }
  function monthCalendar(list, activeB) {
    if (!calYM) calYM = nowYM();
    var yp = calYM.split('-'), yr = +yp[0], mo = +yp[1] - 1;
    var wrap = el('div', { class: 'ldsp-cal' });
    wrap.appendChild(el('div', { class: 'ldsp-cal__nav' }, [
      el('button', { class: 'ldsp-cal__arw', type: 'button', 'aria-label': 'Previous month', html: '&lsaquo;', onclick: function () { calYM = shiftYM(calYM, -1); render(); } }),
      el('div', { class: 'ldsp-cal__mon', text: MONTHS[mo] + ' ' + yr }),
      el('button', { class: 'ldsp-cal__arw', type: 'button', 'aria-label': 'Next month', html: '&rsaquo;', onclick: function () { calYM = shiftYM(calYM, 1); render(); } })
    ]));
    var first = new Date(yr, mo, 1).getDay();
    var days = new Date(yr, mo + 1, 0).getDate();
    var byDay = {};
    (list || []).forEach(function (b) {
      if (!b.date) return;
      var dp = b.date.split('-');
      if (+dp[0] === yr && (+dp[1] - 1) === mo) { var dnum = +dp[2]; (byDay[dnum] = byDay[dnum] || []).push(b); }
    });
    var grid = el('div', { class: 'ldsp-cal__grid' });
    ['S', 'M', 'T', 'W', 'T', 'F', 'S'].forEach(function (d) { grid.appendChild(el('div', { class: 'ldsp-cal__dow', text: d })); });
    var tIso = nowYM() + '-' + ('0' + new Date().getDate()).slice(-2);
    var i;
    for (i = 0; i < first; i++) grid.appendChild(el('div', { class: 'ldsp-cal__cell ldsp-cal__cell--blank' }));
    for (var dnum = 1; dnum <= days; dnum++) {
      var iso = yr + '-' + ('0' + (mo + 1)).slice(-2) + '-' + ('0' + dnum).slice(-2);
      var cakes = byDay[dnum] || [];
      /* a real button, so a click (desktop), a tap (phone) and Enter/Space all
         start a new cake on this day */
      var cell = el('button', {
        type: 'button',
        class: 'ldsp-cal__cell' + (cakes.length > 1 ? ' ldsp-cal__cell--heavy' : '') + (iso === tIso ? ' ldsp-cal__cell--today' : ''),
        'aria-label': 'New cake on ' + MONTHS[mo] + ' ' + dnum,
        onclick: (function (d) { return function () { pendingNewDate = d; startFile(); }; })(iso)
      }, [el('span', { class: 'ldsp-cal__dnum', text: String(dnum) })]);
      if (cakes.length) {
        var dots = el('span', { class: 'ldsp-cal__dots' });
        cakes.slice(0, 3).forEach(function (b) { dots.appendChild(el('span', { class: 'ldsp-cal__dot ' + statusDotClass(b.status) })); });
        cell.appendChild(dots);
      }
      grid.appendChild(cell);
    }
    wrap.appendChild(grid);
    wrap.appendChild(el('div', { class: 'ldsp-cal__legend' }, [
      calLegend('is-booked', 'booked'), calLegend('is-quoted', 'quoted'), calLegend('is-mut', 'inquiry')
    ]));
    /* this month's cakes, tappable, base of the calendar */
    var monthCakes = [];
    Object.keys(byDay).sort(function (a, b) { return (+a) - (+b); }).forEach(function (dnum) { byDay[dnum].forEach(function (b) { monthCakes.push(b); }); });
    if (monthCakes.length) {
      var ml = el('div', { class: 'ldsp-bklist ldsp-cal__list' });
      monthCakes.forEach(function (b) { ml.appendChild(bkRowWrap(b, activeB)); });
      wrap.appendChild(ml);
    } else {
      wrap.appendChild(el('div', { class: 'ldsp-cal__empty', text: 'No cakes this month.' }));
    }
    return wrap;
  }

  function renderBookings(frag, activeB) {
    frag.appendChild(el('div', { class: 'ldsp-viewhead' }, [
      el('div', {}, [el('div', { class: 'ldsp-bookhead__eyebrow', text: 'Your client files' }), el('div', { class: 'ldsp-quickhead__h', text: 'Bookings' })]),
      el('button', { class: 'ldsp-open', type: 'button', onclick: startFile }, ['+ New cake'])
    ]));
    if (pendingUpsell) frag.appendChild(proUpsell());
    var store = F.readStore ? F.readStore() : { bookings: [] };
    var all = store.bookings || [];
    /* UX 2026-09-07: archived files are reachable again via a foot-of-list
       toggle (they were dropped with no way back except the Planner). Rows
       mid-undo (pendingDeletes) hide immediately. */
    var showArch = !!ui.showArchived;
    var archivedCount = all.filter(function (b) { return b.status === 'archived' && pendingDeletes[b.id] == null; }).length;
    var list = all.filter(function (b) {
      if (pendingDeletes[b.id] != null) return false;
      return showArch ? true : b.status !== 'archived';
    });
    /* 2026-09-17 (Mariya): soonest first - the cake coming up next sits at the
       top, not the furthest one. Dated cakes ascend; a cake with no event date
       sinks below them (it isn't "coming up"), ordered by when it was created. */
    list.sort(function (a, b) {
      var da = a.date || '', db = b.date || '';
      if (!da && !db) return (a.created || '').localeCompare(b.created || '');
      if (!da) return 1;
      if (!db) return -1;
      return da.localeCompare(db);
    });
    if (!list.length) {
      frag.appendChild(el('div', { class: 'ldsp-empty' }, [
        el('div', { class: 'ldsp-empty__h', text: 'No cakes yet' }),
        el('div', { class: 'ldsp-empty__sub', text: 'Start a client file and it runs the whole workflow, sizing to the paid quote, on one screen.' }),
        el('button', { class: 'ldsp-open ldsp-open--cta', type: 'button', onclick: startFile }, ['Start a cake file'])
      ]));
    } else {
      /* UX 2026-09-08 (bookings restructure): Calendar ⇄ Client files toggle.
         Calendar = the month (with ‹ › nav) + that month's cakes; Client files =
         the full list. The choice persists in ui.bkView. */
      var bkView = (ui.bkView === 'files') ? 'files' : 'calendar';
      frag.appendChild(el('div', { class: 'ldsp-seg' }, [
        segBtn('Calendar', bkView === 'calendar', function () { ui.bkView = 'calendar'; saveUi(); render(); }),
        segBtn('Client files', bkView === 'files', function () { ui.bkView = 'files'; saveUi(); render(); })
      ]));
      if (bkView === 'calendar') {
        frag.appendChild(monthCalendar(list, activeB));
      } else {
        var wrap = el('div', { class: 'ldsp-bklist' });
        list.forEach(function (b) { wrap.appendChild(bkRowWrap(b, activeB)); });
        frag.appendChild(wrap);
      }
    }
    if (archivedCount > 0) {
      frag.appendChild(el('div', { class: 'ldsp-archrow' }, [
        el('button', { class: 'ldsp-showarch', type: 'button', onclick: function () { ui.showArchived = !showArch; saveUi(); render(); } },
          [showArch ? 'Hide archived' : 'Show archived (' + archivedCount + ')'])
      ]));
    }
    frag.appendChild(tabsEl('bookings'));
  }

  /* ---- Account: plan, upgrade, data, links ---- */
  function tierNow() {
    try { var h = document.querySelector('[data-lh-tier]'); var t = h && h.getAttribute('data-lh-tier'); return (t === 'free' || t === 'premium' || t === 'visitor') ? t : 'visitor'; }
    catch (e) { return 'visitor'; }
  }
  function isAcademy() {
    try { var h = document.querySelector('[data-lh-academy]'); return !!(h && h.getAttribute('data-lh-academy') === 'true'); }
    catch (e) { return false; }
  }
  /* the cross-platform switch: mirrors the Academy spine's "Toolkit →" header
     link. Eyebrow left so the member always knows which side they are on;
     gold door-link right to jump to the Academy (since Build 01, its courses
     home; the old Lessons / Build Sheets / Workshop / My Work shell is
     retired). Academy members only (see render()). */
  function academySwitch() {
    /* Academy Build 01 (2026-10-08): the Academy's front door is the courses home
       now; /pages/academy (the old app shell) is retired. */
    return el('div', { class: 'ldsp-xtop' }, [
      el('span', { class: 'ldsp-xtop__eye', text: "LAYER’D Toolkit" }),
      el('a', { class: 'ldsp-xtop__cross', href: '/pages/courses' }, ['Academy →'])
    ]);
  }
  /* the custom account link the theme header uses (dashboard when signed in,
     the login return-to when not) — passed in on the mount so we match it. */
  function accountLink() {
    try {
      var h = document.querySelector('[data-lh-account-url]');
      var u = h && h.getAttribute('data-lh-account-url');
      return u || '/pages/dashboard';
    } catch (e) { return '/pages/dashboard'; }
  }
  function accountLinkLabel() {
    try {
      var h = document.querySelector('[data-lh-account-label]');
      var l = h && h.getAttribute('data-lh-account-label');
      return l || 'Your account';
    } catch (e) { return 'Your account'; }
  }
  /* UX 2026-09-07: the paid product page (like the dashboard's upsells), passed
     in on the mount since assets can't read Liquid settings. The brand link
     still goes to the About page; only the buy CTAs point here. */
  function proUrl() {
    try { var u = mount.getAttribute('data-lh-pro-url'); return u || '/products/learn-hub-pro'; } catch (e) { return '/products/learn-hub-pro'; }
  }
  /* the plan name shown in Account: Academy > Toolkit (Pro) > Free */
  function planLabel(tier) {
    if (isAcademy()) return 'Academy';
    if (tier === 'premium') return 'Toolkit Pro';
    return 'Free';
  }
  /* UX 2026-09-07 (finding 4): one settings surface. The studio dropped its own
     currency/units card and embeds the shared settings component
     (learn-components.js mountSettings, the same panel every tool's gear opens),
     so measurements, currency, mixer bowl, studio details and data have a single
     owner and can't drift. The studio-only plan + upgrade sit above it; account
     is in the top row, export lives inside the shared component. It's mounted
     after the swap (see render()); data-ld-settings-modal renders it expanded. */
  function renderSettings(frag) {
    markSettingsSeen();   /* opening settings clears the "prices in X" nudge */
    var head = [el('div', { class: 'ldsp-bookhead__eyebrow', text: 'Studio settings' }), el('div', { class: 'ldsp-quickhead__h', text: 'Settings' })];
    frag.appendChild(el('div', { class: 'ldsp-viewhead' }, [el('div', {}, head)]));

    var tier = tierNow(); var academy = isAcademy();
    frag.appendChild(el('div', { class: 'ldsp-card' }, [el('div', { class: 'ldsp-rows' }, [
      row('Plan', planLabel(tier)),
      row('Cakes saved', String(F.fileCount ? F.fileCount() : 0))
    ])]));
    if (tier !== 'premium' && !academy) {
      /* UX 2026-09-09 (Mariya: one place that says what Pro unlocks). The list
         mirrors every locked panel across the tools — keep it in step with them.
         No price here: the product page shows it live in the shopper's currency. */
      var proList = el('ul', { class: 'ldsp-prolist' });
      [
        'Unlimited cake files. Free keeps one.',
        'The whole season on one calendar. Every order merged into one production schedule, heavy days flagged.',
        'Structure for 3 to 6 tiers, tall and double-barrel.',
        'Pricing with your own rates, break-even from your numbers, and the printable quote sheet.',
        'Batch Math saved recipes and the production-day plan.',
        '100 recipe slots, synced to your account. Free keeps 3.',
        'Push reminders before each production day.',
        'Cake ER fix steps and tips, not just the diagnosis.',
        'Clean prints, no watermark: the serving plan and the quote.'
      ].forEach(function (t) { proList.appendChild(el('li', { text: t })); });
      frag.appendChild(el('div', { class: 'ldsp-upsell' }, [
        el('div', { class: 'ldsp-upsell__h', text: 'What Toolkit Pro unlocks' }),
        proList,
        el('div', { class: 'ldsp-upsell__sub', text: 'Included with the Academy.' }),
        el('a', { class: 'ldsp-open', href: proUrl() }, ['Unlock Toolkit Pro →'])
      ]));
    }

    /* the shared settings panel mounts into this host after the swap (see
       mountSharedSettings, which retries until learn-components.js has loaded).
       The link inside is the no-JS fallback if that bundle never arrives.
       2026-09-15 (Mariya: "when i click toolkit settings in the account page it
       redirects me to the toolkit product page"). The fallback used to point at
       /pages/toolkit#settings - the product page - so on the rare paint before
       the card mounts, tapping it dumped her there. It stays in the Studio's own
       settings now; and mountSharedSettings makes the card land reliably so this
       link is almost never seen. */
    frag.appendChild(el('div', { class: 'ldsp-setmount', 'data-ld-settings': '', 'data-ld-settings-modal': '' }, [
      el('a', { class: 'ldsp-open ldsp-open--ghost', href: '/pages/studio?ldsp=account' }, ['Open settings →'])
    ]));

    /* UX 2026-09-07 (design pass): account / get-the-app / about — the routes
       that used to live in the top row now live under the Account tab. */
    function srow(label, sub, action) {
      return el('button', { class: 'ldsp-setrow', type: 'button', onclick: action }, [
        el('span', { class: 'ldsp-setrow__main' }, [el('span', { class: 'ldsp-setrow__lbl', text: label })].concat(sub ? [el('span', { class: 'ldsp-setrow__sub', text: sub })] : [])),
        el('span', { class: 'ldsp-setrow__go', text: '›' })
      ]);
    }
    var links = el('div', { class: 'ldsp-setlist' });
    var signedIn = accountLinkLabel() !== 'Log in';
    links.appendChild(srow(signedIn ? 'My account' : 'Log in', signedIn ? 'Sync and billing' : 'Sign in to sync your cakes across devices', function () { location.href = accountLink(); }));
    var pwa = window.LdPwa; var standalone = document.documentElement.classList.contains('ld-standalone');
    if (pwa && pwa.open && !standalone && !(pwa.installed && pwa.installed())) {
      links.appendChild(srow('Get the app', 'Install the Toolkit on this device', function () { try { pwa.open(); } catch (e) { } }));
    }
    links.appendChild(srow('About the Toolkit', 'What it does, and pricing', function () { location.href = '/pages/toolkit'; }));
    frag.appendChild(links);

    /* 2026-09-14 (Mariya): "Report a problem" sits at the very bottom, below
       Account and About. The shared settings card fills this host (it renders
       the link into [data-ld-report] instead of inside itself). */
    frag.appendChild(el('div', { class: 'ldsp-reportrow', 'data-ld-report': '' }));

    frag.appendChild(tabsEl('account'));
  }

  function renderMobile(frag, b, money, isCake) {
    var activeTab = isCake ? 'cake' : 'tools';
    if (isCake && !b) { frag.appendChild(emptyCard()); frag.appendChild(tabsEl(activeTab)); return; }
    if (isCake) {
      var flip = cakeFlipNav(b);
      if (flip) frag.appendChild(flip);
      frag.appendChild(bookHead(b));
      frag.appendChild(summaryBar(money, true));
    }
    else frag.appendChild(quickHead());

    var steps = el('div', { class: 'ldsp-steps' });
    var shownProd = false;
    STEPS.forEach(function (st) {
      /* the Client file is cake-scoped reference — not a "just the math" tool, so
         it doesn't appear in Quick tools */
      if (st.id === 'clientfile' && !isCake) return;
      var s = stepState(st, b, money, isCake);
      if (isCake && st.phase === 'production' && !shownProd) {
        shownProd = true;
        steps.appendChild(el('div', { class: 'ldsp-phase' }, [
          el('span', { class: 'ldsp-phase__k', text: 'Production' }), el('span', { class: 'ldsp-phase__rule' })
        ]));
      }
      var open = !s.locked && ui.open === st.id;
      var head = el('button', {
        class: 'ldsp-head', type: 'button', 'aria-expanded': String(open),
        onclick: function () { if (s.locked) return; ui.open = (ui.open === st.id ? null : st.id); saveUi(); render(); }
      }, [markEl(s, isCake, open, st), el('span', { class: 'ldsp-name', text: st.name }), el('span', { class: 'ldsp-answer' + (open ? ' is-active' : ''), text: s.answer }), el('span', { class: 'ldsp-chev', text: '⌄' })]);
      var stepEl = el('div', { class: 'ldsp-step' + (s.locked ? ' ldsp-step--locked' : '') }, [head]);
      if (open) stepEl.appendChild(stepBody(st, b, money, isCake, s));
      steps.appendChild(stepEl);
    });
    frag.appendChild(steps);
    /* UX 2026-09-09: in Tools, the directory of everything else (see TOOL_DIRECTORY) */
    if (!isCake) {
      var dir = TOOL_DIRECTORY.filter(function (t) { return !t.hidden; });
      if (dir.length) {
        frag.appendChild(el('div', { class: 'ldsp-subhead ldsp-tooldir__h', text: 'More tools' }));
        var dl = el('div', { class: 'ldsp-setlist ldsp-tooldir' });
        dir.forEach(function (t) {
          dl.appendChild(el('a', { class: 'ldsp-setrow', href: withReturn(toolUrl(t.id, null)) }, [
            el('span', { class: 'ldsp-setrow__main' }, [
              el('span', { class: 'ldsp-setrow__lbl', text: t.name }),
              el('span', { class: 'ldsp-setrow__sub', text: t.sub })
            ]),
            el('span', { class: 'ldsp-setrow__go', html: '&rsaquo;' })
          ]));
        });
        frag.appendChild(dl);
      }
    }
    if (!isCake) frag.appendChild(el('div', { class: 'ldsp-quicknote' }, [el('span', { html: 'Nothing here is saved. Open a tool and tap <em>Save into a cake file</em> to keep it.' })]));
    frag.appendChild(tabsEl(activeTab));
  }

  function renderDesktop(frag, b, money, isCake) {
    var activeTab = isCake ? 'cake' : 'tools';
    if (isCake && !b) { var wrap0 = el('div', { class: 'ldsp-solo' }, [emptyCard()]); frag.appendChild(wrap0); frag.appendChild(tabsEl(activeTab)); return; }

    /* selected step: keep one always open on desktop; never a locked one */
    var sel = ui.open;
    if (!sel || stepState(STEPS.filter(function (s) { return s.id === sel; })[0] || STEPS[0], b, money, isCake).locked) sel = firstOpenable(b, money, isCake);

    /* ----- left rail: modes + identity + step index ----- */
    var rail = el('aside', { class: 'ldsp-rail' });
    rail.appendChild(isCake ? bookHead(b) : quickHead());

    var index = el('div', { class: 'ldsp-index' });
    var shownProd = false;
    STEPS.forEach(function (st) {
      var s = stepState(st, b, money, isCake);
      if (isCake && st.phase === 'production' && !shownProd) {
        shownProd = true;
        index.appendChild(el('div', { class: 'ldsp-phase' }, [
          el('span', { class: 'ldsp-phase__k', text: 'Production' }), el('span', { class: 'ldsp-phase__rule' })
        ]));
      }
      var selected = !s.locked && st.id === sel;
      var irow = el('button', {
        class: 'ldsp-irow' + (selected ? ' is-sel' : '') + (s.locked ? ' is-locked' : ''), type: 'button',
        onclick: function () { if (s.locked) return; ui.open = st.id; saveUi(); render(); }
      }, [markEl(s, isCake, selected), el('span', { class: 'ldsp-irow__name', text: st.name }), el('span', { class: 'ldsp-irow__ans', text: s.answer })]);
      index.appendChild(irow);
    });
    rail.appendChild(index);
    rail.appendChild(tabsEl(activeTab));

    /* ----- working column: summary bar + the selected step ----- */
    var work = el('main', { class: 'ldsp-work' });
    if (isCake) work.appendChild(summaryBar(money));
    var st = STEPS.filter(function (s) { return s.id === sel; })[0] || STEPS[0];
    var s = stepState(st, b, money, isCake);
    var panel = el('section', { class: 'ldsp-panel' }, [
      el('div', { class: 'ldsp-panel__head' }, [
        el('h2', { class: 'ldsp-panel__title', text: st.name }),
        el('span', { class: 'ldsp-panel__ans', text: s.answer })
      ]),
      stepBody(st, b, money, isCake, s)
    ]);
    work.appendChild(panel);
    if (!isCake) work.appendChild(el('div', { class: 'ldsp-quicknote' }, [el('span', { html: 'Nothing here is saved. Tap <em>Save into a cake file</em> inside a tool to keep it.' })]));

    frag.appendChild(el('div', { class: 'ldsp-shell' }, [rail, work]));
  }

  /* ---- wide (1200px+): see MQW above ---- */
  function monthKey(iso) { return iso ? String(iso).slice(0, 7) : ''; }
  function monthTitle(ym) { if (!ym) return 'No date yet'; var p = ym.split('-'); return MONTHS[(+p[1]) - 1] + ' ' + p[0]; }
  /* the pipeline stage a status sits in (Delivered and In production read as booked) */
  function stageOf(st) {
    if (st === 'quoted') return 'quoted';
    if (st === 'booked' || st === 'production_ready' || st === 'delivered') return 'booked';
    if (st === 'archived') return 'archived';
    return 'inquiry';
  }
  /* the same list Bookings shows: archived only on request, rows mid-undo
     hidden, soonest first, undated cakes after the dated ones */
  function activeFiles() {
    var store = F.readStore ? F.readStore() : { bookings: [] };
    var all = store.bookings || [];
    var showArch = !!ui.showArchived;
    var archivedCount = all.filter(function (x) { return x.status === 'archived' && pendingDeletes[x.id] == null; }).length;
    var list = all.filter(function (x) {
      if (pendingDeletes[x.id] != null) return false;
      return showArch ? true : x.status !== 'archived';
    });
    list.sort(function (a, b) {
      var da = a.date || '', db = b.date || '';
      if (!da && !db) return (a.created || '').localeCompare(b.created || '');
      if (!da) return 1;
      if (!db) return -1;
      return da.localeCompare(db);
    });
    return { list: list, archivedCount: archivedCount, showArch: showArch };
  }
  function archToggle(fl) {
    if (!(fl.archivedCount > 0)) return null;
    return el('button', { class: 'ldsp-showarch ldsp-w-arch', type: 'button', onclick: function () { ui.showArchived = !fl.showArch; saveUi(); render(); } },
      [fl.showArch ? 'Hide archived' : 'Show archived (' + fl.archivedCount + ')']);
  }
  /* opening a cake from anywhere on the wide screens, same as a bookings row */
  function openCake(x) { if (F.setActiveBooking) F.setActiveBooking(x.id, 'toolkit'); ui.view = 'cake'; ui.mode = 'cake'; ui.open = 'clientfile'; saveUi(); render(); }

  function filesColumn(activeB) {
    var fl = activeFiles();
    var f = ui.fileFilter || 'all';
    var col = el('aside', { class: 'ldsp-w-col ldsp-w-files', 'aria-label': 'Cake files' });
    col.appendChild(el('div', { class: 'ldsp-w-colhead' }, [
      el('h2', { class: 'ldsp-w-h', text: 'Cake files' }),
      el('button', { class: 'ldsp-w-new', type: 'button', onclick: startFile }, ['+ New cake'])
    ]));
    var counts = { inquiry: 0, quoted: 0, booked: 0 };
    fl.list.forEach(function (x) { var k = stageOf(x.status); if (counts[k] != null) counts[k]++; });
    var chips = el('div', { class: 'ldsp-w-chips', role: 'group', 'aria-label': 'Show cake files' });
    [['all', 'All'], ['inquiry', 'Inquiry'], ['quoted', 'Quoted'], ['booked', 'Booked']].forEach(function (c) {
      var on = f === c[0];
      chips.appendChild(el('button', {
        class: 'ldsp-w-chip' + (on ? ' is-on' : ''), type: 'button', 'aria-pressed': on ? 'true' : 'false',
        onclick: function () { ui.fileFilter = c[0]; saveUi(); render(); }
      }, [c[1] + (c[0] !== 'all' && counts[c[0]] ? ' ' + counts[c[0]] : '')]));
    });
    col.appendChild(chips);
    var shown = fl.list.filter(function (x) { return f === 'all' || stageOf(x.status) === f; });
    if (!shown.length) col.appendChild(el('p', { class: 'ldsp-w-none', text: 'No cake files here yet.' }));
    var lastM = null, group = null;
    shown.forEach(function (x) {
      var m = monthKey(x.date);
      if (group === null || m !== lastM) {
        lastM = m;
        col.appendChild(el('p', { class: 'ldsp-w-month', text: monthTitle(m) }));
        group = el('div', { class: 'ldsp-bklist ldsp-w-list' });
        col.appendChild(group);
      }
      group.appendChild(bkRowWrap(x, activeB));
    });
    var at = archToggle(fl);
    if (at) col.appendChild(at);
    return col;
  }

  function comingUp(activeB, money) {
    var fl = activeFiles();
    var t0 = new Date(); t0.setHours(0, 0, 0, 0);
    var next = fl.list.filter(function (x) {
      if (!x.date || x.status === 'archived') return false;
      var d = new Date(x.date + 'T00:00:00');
      return !isNaN(d) && d >= t0;
    }).slice(0, 6);
    var side = el('aside', { class: 'ldsp-w-col ldsp-w-side', 'aria-label': 'Coming up' });
    side.appendChild(el('p', { class: 'ldsp-w-eyebrow', text: 'Coming up' }));
    side.appendChild(el('h2', { class: 'ldsp-w-h', text: next.length ? (next.length === 1 ? 'The next cake' : 'The next ' + next.length + ' cakes') : 'Nothing dated yet' }));
    if (next.length) {
      var ol = el('ol', { class: 'ldsp-w-next' });
      next.forEach(function (x) {
        var days = Math.round((new Date(x.date + 'T00:00:00') - t0) / 86400000);
        var cd = days === 0 ? 'today' : days === 1 ? 'tomorrow' : days + ' days';
        ol.appendChild(el('li', {}, [el('button', {
          class: 'ldsp-w-next__row' + (activeB && activeB.id === x.id ? ' is-active' : ''), type: 'button',
          onclick: function () { openCake(x); }
        }, [
          el('span', { class: 'ldsp-w-next__when', text: prettyDate(x.date).replace(' ›', '') }),
          el('span', { class: 'ldsp-w-next__main' }, [
            el('span', { class: 'ldsp-w-next__name', text: x.name || 'Untitled cake' }),
            el('span', { class: 'ldsp-w-next__cd', text: cd + ' · ' + statusLabel(x.status) })
          ])
        ])]));
      });
      side.appendChild(ol);
    } else {
      side.appendChild(el('p', { class: 'ldsp-w-none', text: 'Give a cake file an event date and it shows here.' }));
    }
    if (activeB) {
      /* the production doors only once the production steps are open for this
         cake (the same lock the Planner and Recipes steps show) */
      var prodOpen = !stepState(STEPS.filter(function (x) { return x.id === 'planner'; })[0], activeB, money, true).locked;
      var doors = [['The quote sheet', doorHref('pricing', activeB.id) + '#print']];
      if (prodOpen) doors = [['The Planner', plannerHref(activeB)], ['Shopping list', plannerShopHref(activeB)], ['Batch Math', doorHref('batch', activeB.id)]].concat(doors);
      side.appendChild(el('p', { class: 'ldsp-w-eyebrow ldsp-w-gap', text: 'For this cake' }));
      var box = el('div', { class: 'ldsp-w-doors' });
      doors.forEach(function (d) { box.appendChild(el('a', { class: 'ldsp-w-door', href: d[1] }, [d[0] + ' →'])); });
      side.appendChild(box);
    }
    return side;
  }

  /* wide Settings: an index on the left (jumps to a section on click, explicit
     navigation only), the same settings in the middle (renderSettings builds
     them, nothing is re-implemented), and on the right how the quote letterhead
     prints, read from the studio details the shared settings card saves on this
     device (layerd-studio-*). It repaints as she types. */
  function studioVal(k) { try { return localStorage.getItem('layerd-studio-' + k) || ''; } catch (e) { return ''; } }
  function letterheadPreview(b, money) {
    var side = el('aside', { class: 'ldsp-w-col ldsp-w-side ldsp-w-preview', 'aria-label': 'Quote letterhead preview' });
    side.appendChild(el('p', { class: 'ldsp-w-eyebrow', text: 'Preview' }));
    side.appendChild(el('h2', { class: 'ldsp-w-h', text: 'How your quote prints' }));
    var paper = el('div', { class: 'ldsp-w-paper' });
    function paint() {
      var name = studioVal('name'), contact = studioVal('contact'), logo = studioVal('logo'), color = studioVal('color');
      var c = /^#[0-9a-fA-F]{6}$/.test(color) ? color : '';
      paper.innerHTML = '';
      paper.appendChild(el('div', { class: 'ldsp-w-paper__rule', style: c ? 'background:' + c : null }));
      if (logo && logo.indexOf('data:image/') === 0) paper.appendChild(el('img', { class: 'ldsp-w-paper__logo', src: logo, alt: '' }));
      paper.appendChild(el('p', { class: 'ldsp-w-paper__biz' + (name ? '' : ' is-empty'), text: name || 'Your business name', style: c ? 'color:' + c : null }));
      paper.appendChild(el('p', { class: 'ldsp-w-paper__contact' + (contact ? '' : ' is-empty'), text: contact || 'Your contact line' }));
      if (b) {
        var sv = F.servingsOfBooking ? F.servingsOfBooking(b) : 0;
        paper.appendChild(el('p', { class: 'ldsp-w-paper__client', text: b.name || 'Untitled cake' }));
        paper.appendChild(el('p', { class: 'ldsp-w-paper__meta', text: [b.date ? prettyDate(b.date).replace(' ›', '') : null, sv ? sv + ' servings' : null].filter(Boolean).join(' · ') }));
        var q = money && money.quote != null ? fmtMoney(money.quote, true) : null;
        paper.appendChild(el('div', { class: 'ldsp-w-paper__total', style: c ? 'border-top-color:' + c : null }, [
          el('span', { text: 'Total' }), el('span', { class: 'ldsp-w-paper__fig', text: q || 'not priced yet', style: c ? 'color:' + c : null })
        ]));
      }
    }
    paint();
    side.appendChild(paper);
    side.appendChild(el('p', { class: 'ldsp-w-none', text: b ? 'Shown with the cake you have open.' : 'Open a cake file to see it on a quote.' }));
    side._paint = paint;
    return side;
  }
  function findSection(root, label) {
    if (label.charAt(0) === '.') return root.querySelector(label);
    var want = label.toLowerCase();
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var n = all[i];
      if (n.children.length) continue;
      var t = (n.textContent || '').trim().toLowerCase();
      if (t && t.indexOf(want) === 0) return n;
    }
    return null;
  }
  function renderSettingsWide(frag, b, money) {
    var tmp = document.createDocumentFragment();
    renderSettings(tmp);
    var tabs = null;
    for (var c = tmp.firstChild; c; c = c.nextSibling) { if (c.classList && c.classList.contains('ldsp-tabs')) tabs = c; }
    if (tabs) tmp.removeChild(tabs);
    var main = el('main', { class: 'ldsp-w-work ldsp-w-setmain' });
    main.appendChild(tmp);
    var preview = letterheadPreview(b, money);
    /* the shared card saves on input/change; repaint the letterhead after it */
    function later() { setTimeout(function () { try { preview._paint(); } catch (e) { } }, 60); }
    main.addEventListener('input', later);
    main.addEventListener('change', later);
    main.addEventListener('click', later);
    var idx = el('aside', { class: 'ldsp-w-col ldsp-w-files ldsp-w-setidx', 'aria-label': 'Settings sections' });
    idx.appendChild(el('h2', { class: 'ldsp-w-h', text: 'Settings' }));
    idx.appendChild(el('p', { class: 'ldsp-w-none', text: 'Set these once. Every tool follows.' }));
    var nav = el('nav', { class: 'ldsp-w-toollist' });
    [['Your plan', '.ldsp-card'], ['Measurements', 'Measurements'], ['Currency', 'Currency'], ['Mixer bowl', 'Mixer bowl'],
     ['Your studio on quotes', 'Business name'], ['Your data', 'Your data'], ['Production reminders', 'Production reminders'], ['Account and app', '.ldsp-setlist']
    ].forEach(function (it) {
      nav.appendChild(el('button', {
        class: 'ldsp-w-tool', type: 'button',
        onclick: function () { var t = findSection(main, it[1]); if (t && t.scrollIntoView) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      }, [el('span', { class: 'ldsp-w-tool__name', text: it[0] })]));
    });
    idx.appendChild(nav);
    frag.appendChild(el('div', { class: 'ldsp-w-shell ldsp-w-shell--set' }, [idx, main, preview]));
    if (tabs) frag.appendChild(tabs);
  }

  function renderCakeWide(frag, b, money) {
    var main = el('main', { class: 'ldsp-w-work' });
    main.appendChild(bookHead(b));
    main.appendChild(summaryBar(money));
    var grid = el('div', { class: 'ldsp-w-grid' });
    var shownProd = false;
    STEPS.forEach(function (st) {
      var s = stepState(st, b, money, true);
      if (st.phase === 'production' && !shownProd) {
        shownProd = true;
        grid.appendChild(el('div', { class: 'ldsp-phase ldsp-w-phase' }, [
          el('span', { class: 'ldsp-phase__k', text: 'Production' }), el('span', { class: 'ldsp-phase__rule' })
        ]));
      }
      var full = st.id === 'size' || st.id === 'structure' || st.id === 'cost';
      grid.appendChild(el('section', { class: 'ldsp-w-panel' + (full ? ' ldsp-w-panel--full' : '') + (s.locked ? ' is-locked' : ''), 'aria-label': st.name }, [
        el('div', { class: 'ldsp-w-panel__head' }, [
          markEl(s, true, false, st),
          el('h2', { class: 'ldsp-w-panel__title', text: st.name }),
          el('span', { class: 'ldsp-w-panel__ans', text: s.answer })
        ]),
        stepBody(st, b, money, true, s)
      ]));
    });
    main.appendChild(grid);
    frag.appendChild(el('div', { class: 'ldsp-w-shell ldsp-w-shell--cake' }, [filesColumn(b), main, comingUp(b, money)]));
    frag.appendChild(tabsEl('cake'));
  }

  function renderToolsWide(frag, b, money) {
    var tools = STEPS.filter(function (st) { return st.id !== 'clientfile'; });
    var sel = ui.toolSel;
    if (!tools.some(function (t) { return t.id === sel; })) sel = 'size';
    var list = el('aside', { class: 'ldsp-w-col ldsp-w-files ldsp-w-tools', 'aria-label': 'Tools' });
    list.appendChild(quickHead());
    var nav = el('div', { class: 'ldsp-w-toollist' });
    tools.forEach(function (st) {
      var s = stepState(st, b, money, false);
      var on = st.id === sel;
      nav.appendChild(el('button', {
        class: 'ldsp-w-tool' + (on ? ' is-on' : ''), type: 'button', 'aria-current': on ? 'true' : null,
        onclick: function () { ui.toolSel = st.id; saveUi(); render(); }
      }, [el('span', { class: 'ldsp-w-tool__name', text: st.name }), el('span', { class: 'ldsp-w-tool__sub', text: s.answer || st.quick })]));
    });
    TOOL_DIRECTORY.filter(function (t) { return !t.hidden; }).forEach(function (t) {
      nav.appendChild(el('a', { class: 'ldsp-w-tool', href: withReturn(toolUrl(t.id, null)) }, [
        el('span', { class: 'ldsp-w-tool__name', text: t.name + ' →' }), el('span', { class: 'ldsp-w-tool__sub', text: t.sub })
      ]));
    });
    list.appendChild(nav);
    var st = tools.filter(function (t) { return t.id === sel; })[0];
    var s = stepState(st, b, money, false);
    var work = el('main', { class: 'ldsp-w-work' }, [
      el('section', { class: 'ldsp-w-panel ldsp-w-panel--tool', 'aria-label': st.name }, [
        el('div', { class: 'ldsp-w-panel__head' }, [
          el('h2', { class: 'ldsp-w-panel__title ldsp-w-panel__title--big', text: st.name }),
          el('span', { class: 'ldsp-w-panel__ans', text: s.answer })
        ]),
        stepBody(st, b, money, false, s)
      ]),
      el('div', { class: 'ldsp-quicknote' }, [el('span', { html: 'Nothing here is saved. Tap <em>Save into a cake file</em> inside a tool to keep it.' })])
    ]);
    frag.appendChild(el('div', { class: 'ldsp-w-shell ldsp-w-shell--tools' }, [list, work]));
    frag.appendChild(tabsEl('tools'));
  }

  /* the month at full width: the cakes are written into their days. The day
     number starts a new cake on that day (as tapping a day does at every other
     width); a cake opens its file. */
  function monthCalendarWide(list, activeB) {
    if (!calYM) calYM = nowYM();
    var yp = calYM.split('-'), yr = +yp[0], mo = +yp[1] - 1;
    var wrap = el('div', { class: 'ldsp-w-cal' });
    wrap.appendChild(el('div', { class: 'ldsp-w-cal__nav' }, [
      el('button', { class: 'ldsp-cal__arw', type: 'button', 'aria-label': 'Previous month', html: '&lsaquo;', onclick: function () { calYM = shiftYM(calYM, -1); render(); } }),
      el('h2', { class: 'ldsp-w-cal__mon', text: MONTHS[mo] + ' ' + yr }),
      el('button', { class: 'ldsp-cal__arw', type: 'button', 'aria-label': 'Next month', html: '&rsaquo;', onclick: function () { calYM = shiftYM(calYM, 1); render(); } }),
      el('div', { class: 'ldsp-cal__legend ldsp-w-cal__legend' }, [
        calLegend('is-booked', 'booked'), calLegend('is-quoted', 'quoted'), calLegend('is-mut', 'inquiry')
      ])
    ]));
    var first = new Date(yr, mo, 1).getDay();
    var days = new Date(yr, mo + 1, 0).getDate();
    var byDay = {};
    (list || []).forEach(function (x) {
      if (!x.date) return;
      var dp = x.date.split('-');
      if (+dp[0] === yr && (+dp[1] - 1) === mo) { var dn = +dp[2]; (byDay[dn] = byDay[dn] || []).push(x); }
    });
    var grid = el('div', { class: 'ldsp-w-cal__grid' });
    ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].forEach(function (d) { grid.appendChild(el('div', { class: 'ldsp-w-cal__dow', text: d })); });
    var tIso = nowYM() + '-' + ('0' + new Date().getDate()).slice(-2);
    for (var i = 0; i < first; i++) grid.appendChild(el('div', { class: 'ldsp-w-day ldsp-w-day--blank' }));
    for (var dnum = 1; dnum <= days; dnum++) {
      var iso = yr + '-' + ('0' + (mo + 1)).slice(-2) + '-' + ('0' + dnum).slice(-2);
      var cakes = byDay[dnum] || [];
      var cell = el('div', { class: 'ldsp-w-day' + (cakes.length > 1 ? ' is-heavy' : '') + (iso === tIso ? ' is-today' : '') }, [
        el('button', {
          class: 'ldsp-w-day__n', type: 'button', 'aria-label': 'New cake on ' + MONTHS[mo] + ' ' + dnum,
          onclick: (function (d) { return function () { pendingNewDate = d; startFile(); }; })(iso)
        }, [String(dnum)])
      ]);
      cakes.forEach(function (x) {
        var sv = F.servingsOfBooking ? F.servingsOfBooking(x) : 0;
        cell.appendChild(el('button', {
          class: 'ldsp-w-cake ldsp-w-cake--' + stageOf(x.status) + (activeB && activeB.id === x.id ? ' is-active' : ''), type: 'button',
          onclick: function () { openCake(x); }
        }, [
          el('span', { class: 'ldsp-w-cake__name', text: x.name || 'Untitled cake' }),
          el('span', { class: 'ldsp-w-cake__meta', text: [statusLabel(x.status), sv ? sv + ' servings' : null].filter(Boolean).join(' · ') })
        ]));
      });
      grid.appendChild(cell);
    }
    wrap.appendChild(grid);
    return wrap;
  }

  function renderBookingsWide(frag, activeB) {
    frag.appendChild(el('div', { class: 'ldsp-viewhead' }, [
      el('div', {}, [el('div', { class: 'ldsp-bookhead__eyebrow', text: 'Your client files' }), el('div', { class: 'ldsp-quickhead__h', text: 'Bookings' })]),
      el('button', { class: 'ldsp-open', type: 'button', onclick: startFile }, ['+ New cake'])
    ]));
    if (pendingUpsell) frag.appendChild(proUpsell());
    var fl = activeFiles();
    if (!fl.list.length) {
      frag.appendChild(el('div', { class: 'ldsp-empty' }, [
        el('div', { class: 'ldsp-empty__h', text: 'No cakes yet' }),
        el('div', { class: 'ldsp-empty__sub', text: 'Start a client file and it runs the whole workflow, sizing to the paid quote, on one screen.' }),
        el('button', { class: 'ldsp-open ldsp-open--cta', type: 'button', onclick: startFile }, ['Start a cake file'])
      ]));
      var at0 = archToggle(fl);
      if (at0) frag.appendChild(el('div', { class: 'ldsp-archrow' }, [at0]));
      frag.appendChild(tabsEl('bookings'));
      return;
    }
    var left = el('main', { class: 'ldsp-w-work' }, [monthCalendarWide(fl.list, activeB)]);
    var right = el('aside', { class: 'ldsp-w-col ldsp-w-side ldsp-w-pipe', 'aria-label': 'Pipeline' });
    right.appendChild(el('p', { class: 'ldsp-w-eyebrow', text: 'Pipeline' }));
    var stages = [['inquiry', 'Inquiry'], ['quoted', 'Quoted'], ['booked', 'Booked']];
    if (fl.showArch) stages.push(['archived', 'Archived']);
    stages.forEach(function (g) {
      var items = fl.list.filter(function (x) { return stageOf(x.status) === g[0]; });
      right.appendChild(el('div', { class: 'ldsp-w-colhead ldsp-w-gap' }, [el('h2', { class: 'ldsp-w-h', text: g[1] }), el('span', { class: 'ldsp-w-count', text: String(items.length) })]));
      var box = el('div', { class: 'ldsp-bklist ldsp-w-list' });
      if (!items.length) box.appendChild(el('p', { class: 'ldsp-w-none', text: 'None right now.' }));
      items.forEach(function (x) { box.appendChild(bkRowWrap(x, activeB)); });
      right.appendChild(box);
    });
    var at = archToggle(fl);
    if (at) right.appendChild(at);
    frag.appendChild(el('div', { class: 'ldsp-w-shell ldsp-w-shell--book' }, [left, right]));
    frag.appendChild(tabsEl('bookings'));
  }

  function summaryBar(money, compact) {
    function cell(k, v, cls, unit, step) {
      var vEl = el('div', { class: 'ldsp-cell__v' + (v == null ? ' is-empty' : '') });
      if (v == null) vEl.textContent = '–';
      else { vEl.appendChild(document.createTextNode(v)); if (unit) vEl.appendChild(el('span', { class: 'u', text: unit })); }
      function go() { ui.view = 'cake'; ui.mode = 'cake'; ui.open = step; saveUi(); render(); }
      return el('div', {
        class: 'ldsp-cell' + (cls || ''), role: 'button', tabindex: '0',
        'aria-label': k + ', open ' + step, onclick: go,
        onkeydown: function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } }
      }, [el('div', { class: 'ldsp-cell__k', text: k }), vEl]);
    }
    var m = money || {};
    var stale = m.stale ? ' is-stale' : '';   /* cake resized since it was priced — tap to re-price */
    /* UX 2026-09-07: on mobile the four numbers appeared twice within a screen
       (bar + step rows). Drop "Costs you" from the bar to one row of three; the
       cost floor still shows in the Cost step. Desktop keeps all four. */
    var cells = [cell('Servings', (m.servings != null ? String(m.servings) : null), '', null, 'size')];
    if (!compact) cells.push(cell('Costs you', (m.costSv != null ? fmtMoney(m.costSv) : null), stale, '/sv', 'cost'));
    cells.push(cell('You charge', (m.chargeSv != null ? fmtMoney(m.chargeSv) : null), stale, '/sv', 'cost'));
    cells.push(cell('Quote', (m.quote != null ? fmtMoney(m.quote, true) : null), ' ldsp-cell--quote' + stale, null, 'quote'));
    return el('div', { class: 'ldsp-summary' + (compact ? ' ldsp-summary--3' : '') }, cells);
  }

  /* UX 2026-09-07: the single bottom bar. Absorbs the old Quick tools / This
     cake toggle (now the This cake / Tools tabs), so it's the one nav layer.
     Account moved to the top row; settings to the top-row gear. */
  function tabsEl(activeTab) {
    function tab(lbl, id) {
      var on = activeTab === id;
      /* data-tab: page.studio.liquid hides the courses tab on desktop when the
         LAYER'D bar (which carries courses) is on top (2026-10-09) */
      return el('button', { class: 'ldsp-tab' + (on ? ' is-on' : ''), type: 'button', 'data-tab': id, 'aria-current': on ? 'page' : null }, [
        el('span', { class: 'ldsp-tab__dot' }), el('span', { class: 'ldsp-tab__lbl', text: lbl })
      ]);
    }
    /* Academy Build 01 (2026-10-08, brief 9.1): courses joins before Settings, the
       same six tabs as the shared .ld-tabbar / .lh-tabbar on every other page. */
    var t = el('nav', { class: 'ldsp-tabs', 'aria-label': 'Studio' }, [
      tab('This cake', 'cake'), tab('Bookings', 'bookings'), tab('Tools', 'tools'), tab('Cake ER', 'cakeer'), tab('courses', 'courses'), tab('Settings', 'account')
    ]);
    var btns = t.querySelectorAll('.ldsp-tab');
    btns[0].addEventListener('click', function () { ui.view = 'cake'; ui.mode = 'cake'; saveUi(); render(); });
    btns[1].addEventListener('click', function () { ui.view = 'bookings'; saveUi(); render(); });
    /* Tools = the standalone Quick tools mode (nothing saved) */
    btns[2].addEventListener('click', function () { ui.view = 'cake'; ui.mode = 'quick'; saveUi(); render(); });
    btns[3].addEventListener('click', function () { location.href = withReturn(toolUrl('cake-er', null)); });
    /* the Academy's courses home (not a Studio view, so a plain page load) */
    btns[4].addEventListener('click', function () { location.href = '/pages/courses'; });
    /* UX 2026-09-07 (design pass): Account = settings + account, the gear folded
       into a tab. This matches the shared .ld-tabbar on every tool page, so the
       bar never changes shape when you open a tool. */
    btns[5].addEventListener('click', function () { ui.view = 'settings'; saveUi(); render(); });
    return t;
  }

  function startFile() {
    /* one free file, then Pro — show the upsell on the capped attempt rather
       than failing silently (createInquiry backstops with a null return). */
    if (F.atCap && F.atCap()) {
      pendingNewDate = null; pendingUpsell = true; ui.view = 'bookings'; saveUi(); render();
      /* 2026-10-15 (Mariya: in the desktop app neither a day nor "+ New cake"
         did anything). A signed-out app window reads as a visitor, so every add
         hits the one-file cap, and on the wide calendar the message lands above
         the month, off screen. A tap is explicit navigation, so bring it into view. */
      var up = mount.querySelector('.ldsp-upsell');
      if (up && up.scrollIntoView) { try { up.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { up.scrollIntoView(); } }
      return;
    }
    /* SPINE r240: open the new-cake form so name/date are captured up front,
       instead of silently spawning another file called "New cake". */
    pendingUpsell = false; ui.view = 'newcake'; saveUi(); render();
  }
  /* the new-cake form: name + event date, captured before the file is created */
  function renderNewCake(frag) {
    frag.appendChild(el('div', { class: 'ldsp-viewhead' }, [
      el('div', {}, [el('div', { class: 'ldsp-bookhead__eyebrow', text: 'Start a client file' }), el('div', { class: 'ldsp-quickhead__h', text: 'New cake' })])
    ]));
    var nameIn = el('input', { class: 'ldsp-input', type: 'text', placeholder: 'e.g. Yasmin & Donte wedding', autocomplete: 'off' });
    /* UX 2026-09-07: no silent +30-day default. An invented date makes the
       Planner count back from the wrong day. Leave it empty; add when known. */
    var dateIn = el('input', { class: 'ldsp-input', type: 'date' });
    /* a day tapped on the Bookings calendar arrives pre-filled (still editable) */
    if (pendingNewDate) { dateIn.value = pendingNewDate; pendingNewDate = null; }
    function commit() {
      var name = (nameIn.value || '').trim() || 'Untitled cake';
      var iso = dateIn.value || '';
      var b = F.createInquiry ? F.createInquiry(name, 'toolkit', iso ? { date: iso } : {}) : null;
      if (b && F.setActiveBooking) F.setActiveBooking(b.id, 'toolkit');
      pendingUpsell = false; ui.view = 'cake'; ui.mode = 'cake'; ui.open = 'size'; saveUi();
      render();
    }
    var card = el('div', { class: 'ldsp-card' }, [
      el('label', { class: 'ldsp-field' }, [el('span', { class: 'ldsp-field__lbl', text: 'Cake or client name' }), nameIn]),
      el('label', { class: 'ldsp-field' }, [el('span', { class: 'ldsp-field__lbl', text: 'Event date' }), dateIn, el('div', { class: 'ldsp-field__hint' }, [el('span', { text: 'add when known. you can set it later.' })])]),
      el('div', { class: 'ldsp-field__row' }, [
        el('button', { class: 'ldsp-open ldsp-open--cta', type: 'button', onclick: commit }, ['Create cake file']),
        el('button', { class: 'ldsp-open ldsp-open--ghost', type: 'button', onclick: function () { ui.view = 'bookings'; saveUi(); render(); } }, ['Cancel'])
      ])
    ]);
    frag.appendChild(card);
    frag.appendChild(el('div', { class: 'ldsp-body__note', text: 'You can rename it or change the date any time from the booking.' }));
    frag.appendChild(tabsEl('bookings'));
    /* focus the name field so she can type straight away */
    setTimeout(function () { try { nameIn.focus(); } catch (e) { } }, 30);
  }
  /* the Pro pitch shown when a free baker tries to save a second cake file */
  function proUpsell() {
    /* 2026-10-15: signed out (often an installed app whose login lapsed, since it
       keeps its own cookies) the member only needs to log in, so lead with that */
    if (tierNow() === 'visitor') {
      return el('div', { class: 'ldsp-upsell' }, [
        el('div', { class: 'ldsp-upsell__h', text: 'You’re signed out' }),
        el('div', { class: 'ldsp-upsell__sub', text: 'Log in to add cakes. New here? One cake file is free, and the Toolkit saves every cake.' }),
        el('a', { class: 'ldsp-open', href: accountLink() }, ['Log in →']),
        el('a', { class: 'ldsp-open ldsp-open--ghost', href: proUrl() }, ['Get the Toolkit →']),
        el('button', { class: 'ldsp-open ldsp-open--ghost', type: 'button', onclick: function () { pendingUpsell = false; render(); } }, ['Not now'])
      ]);
    }
    return el('div', { class: 'ldsp-upsell' }, [
      el('div', { class: 'ldsp-upsell__h', text: 'One cake file is included free' }),
      el('div', { class: 'ldsp-upsell__sub', text: 'The Toolkit saves every cake. Unlimited client files, the whole workflow, on all your devices. Your first file stays free.' }),
      el('a', { class: 'ldsp-open', href: proUrl() }, ['Get the Toolkit →']),
      el('button', { class: 'ldsp-open ldsp-open--ghost', type: 'button', onclick: function () { pendingUpsell = false; render(); } }, ['Not now'])
    ]);
  }

  function prettyDate(iso) {
    try { var p = String(iso).split('-'); var mo = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']; return (+p[2]) + ' ' + mo[(+p[1]) - 1] + ' ›'; } catch (e) { return iso; }
  }

  function swap(frag) {
    /* render() sets mount.className (with/without is-desktop) before calling us */
    if (mount.className.indexOf('ld-toolkit') === -1) mount.className = ('ld-toolkit ' + mount.className).trim();
    mount.innerHTML = '';
    /* 2026-09-16 (Mariya: on the website the sidebar hid behind the storefront
       header). On desktop the tab bar must live OUTSIDE the content column and
       IN NORMAL FLOW (not fixed to the viewport). Pull .ldsp-tabs out and wrap
       the rest in .ldsp-main. Since 2026-10-09 the CSS draws the tabs as a row
       above the page (it was a left sidebar). Mobile keeps the frag as-is
       (bottom bar unchanged). */
    if (mount.className.indexOf('is-desktop') !== -1) {
      var tabs = frag.querySelector('.ldsp-tabs');
      if (tabs) {
        frag.removeChild(tabs);
        var main = document.createElement('div');
        main.className = 'ldsp-main';
        while (frag.firstChild) main.appendChild(frag.firstChild);
        mount.appendChild(tabs);
        mount.appendChild(main);
        return;
      }
    }
    mount.appendChild(frag);
  }

  /* store change while the pricing frame is open → refresh the summary bar in
     place, DON'T rebuild (rebuilding would reload the frame mid-quote) */
  function refreshLive() {
    var money = F.readMoney ? F.readMoney() : null;
    var old = mount.querySelector('.ldsp-summary');
    if (old && old.parentNode && money) old.parentNode.replaceChild(summaryBar(money), old);
  }
  /* the embedded Pricing tool reports its content height so the frame fits */
  window.addEventListener('message', function (e) {
    var d = e && e.data;
    if (!d || !d.ldEmbed || !(d.height > 0)) return;
    var fr = mount.querySelector('.ldsp-frame');
    if (fr) fr.style.height = Math.max(360, Math.min(6000, Math.round(d.height) + 8)) + 'px';
  });

  autoArchive();   /* delivered / past-date cakes leave the active list — before the first paint, before onChange */
  render();
  if (F.onChange) F.onChange(function () { if (frameActive) refreshLive(); else render(); });
  /* re-render when crossing the desktop/mobile breakpoint (not a mutation
     observer — the shared rail's r227 lesson: never body-subtree-observe) */
  if (MQ.addEventListener) MQ.addEventListener('change', function () { render(); });
  else if (MQ.addListener) MQ.addListener(function () { render(); });
  if (MQW.addEventListener) MQW.addEventListener('change', function () { render(); });
  else if (MQW.addListener) MQW.addListener(function () { render(); });
})();
